<template>
  <div id="main-top">
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1920 1080" xml:space="preserve">
      <g>
        <path class="st1" d="M1283,200.8c0.9,4.3-1.9,8.5-6.2,9.4c-4.3,0.9-8.5-1.9-9.4-6.2c-0.9-4.3,1.9-8.5,6.2-9.4
          C1277.9,193.7,1282.1,196.5,1283,200.8z M1464.5,397.1c-4.3,0.9-7,5.1-6.2,9.4c0.9,4.3,5.1,7,9.4,6.2c4.3-0.9,7-5.1,6.2-9.4
          C1473,399,1468.8,396.2,1464.5,397.1z M1495.5,594.8c-4.3,0.9-7,5.1-6.2,9.4c0.9,4.3,5.1,7,9.4,6.2c4.3-0.9,7-5.1,6.2-9.4
          C1503.9,596.7,1499.7,593.9,1495.5,594.8z M1447.3,676.6c-4.3,0.9-7,5.1-6.2,9.4c0.9,4.3,5.1,7,9.4,6.2c4.3-0.9,7-5.1,6.2-9.4
          C1455.8,678.5,1451.6,675.7,1447.3,676.6z M1739.8,196.2L1572,228.9l-103.8-68.1L1275,200.9l0.5,2.3l192.3-39.9l103.8,68.1
          l168.7-32.8L1739.8,196.2z M1954.9,667.7l-192.3,39.9l-103.8-68.1l-210.1,43.6l0.5,2.3l209.1-43.4l103.8,68.1l193.3-40.1
          L1954.9,667.7z M1972.1,388.2L1763,431.6l-103.8-68.1l-193.3,40.1l0.5,2.3l192.3-39.9l103.8,68.1l210.1-43.6L1972.1,388.2z
          M1636.2,44.6l77.2-16l-0.5-2.3l-78.2,16.2l-52.1,79.3l-92.5,19.2l0.5,2.3l93.5-19.4L1636.2,44.6z M1642.8,505l77.2-16l-0.5-2.3
          l-78.2,16.2l-52.1,79.3l-92.5,19.2l0.5,2.3l93.5-19.4L1642.8,505z M1556,556.1l9,9.6l13.4-2.8l-9-9.6l4.4-12.3l-13.4,2.8
          L1556,556.1z M1537.4,559.9l9,9.6l13.4-2.8l-9-9.6l4.4-12.3l-13.4,2.8L1537.4,559.9z M1518.7,563.8l9,9.6l13.4-2.8l-9-9.6l4.4-12.3
          l-13.4,2.8L1518.7,563.8z M1500,567.7l9,9.6l13.4-2.8l-9-9.6l4.4-12.3l-13.4,2.8L1500,567.7z M1711.6,19.7c-4.3,0.9-7,5.1-6.2,9.4
          c0.9,4.3,5.1,7,9.4,6.2c4.3-0.9,7-5.1,6.2-9.4S1715.8,18.8,1711.6,19.7z M1738.4,189.6c-4.3,0.9-7,5.1-6.2,9.4s5.1,7,9.4,6.2
          c4.3-0.9,7-5.1,6.2-9.4C1746.9,191.5,1742.7,188.7,1738.4,189.6z M1970.7,381.6c-4.3,0.9-7,5.1-6.2,9.4c0.9,4.3,5.1,7,9.4,6.2
          c4.3-0.9,7-5.1,6.2-9.4C1979.2,383.5,1975,380.7,1970.7,381.6z M1715.6,480.6c-4.3,0.9-7,5.1-6.2,9.4c0.9,4.3,5.1,7,9.4,6.2
          s7-5.1,6.2-9.4C1724.1,482.4,1719.9,479.7,1715.6,480.6z M1953.5,661.1c-4.3,0.9-7,5.1-6.2,9.4c0.9,4.3,5.1,7,9.4,6.2
          s7-5.1,6.2-9.4C1962,663,1957.8,660.2,1953.5,661.1z M1723.6,59.3l-0.7-2.2c-0.7,0.2-1.4,0.4-2.2,0.6l0.6,2.3
          C1722.1,59.8,1722.9,59.6,1723.6,59.3z M1711.8,58.6c-0.8,0-1.5-0.1-2.3-0.2l-0.3,2.3c0.8,0.1,1.6,0.2,2.4,0.2L1711.8,58.6z
          M1734.2,53.5l-1.5-1.8c-0.6,0.5-1.2,0.9-1.8,1.4l1.3,1.9C1733,54.5,1733.6,54,1734.2,53.5z M1700.8,56.1c-0.7-0.3-1.4-0.6-2-1
          l-1.1,2.1c0.7,0.4,1.4,0.7,2.2,1.1L1700.8,56.1z M1742.1,44.3l-2-1.2c-0.4,0.7-0.8,1.3-1.2,1.9l1.9,1.3
          C1741.2,45.7,1741.7,45,1742.1,44.3z M1691.5,49.8c-0.5-0.5-1.1-1.1-1.6-1.6l-1.8,1.5c0.5,0.6,1.1,1.2,1.7,1.8L1691.5,49.8z
          M1746.1,33l-2.3-0.4c-0.1,0.7-0.3,1.5-0.4,2.2l2.3,0.5C1745.9,34.6,1746,33.8,1746.1,33z M1685.1,40.6c-0.3-0.7-0.6-1.4-0.9-2.1
          l-2.2,0.8c0.3,0.8,0.6,1.5,0.9,2.2L1685.1,40.6z M1745.9,20.9l-2.3,0.5c0.2,0.7,0.3,1.5,0.4,2.2l2.3-0.3
          C1746.2,22.5,1746,21.7,1745.9,20.9z M1745.7,20.4c-0.2-0.8-0.4-1.6-0.6-2.4l-2.2,0.7c0.2,0.7,0.4,1.4,0.6,2.2L1745.7,20.4z
          M1682.2,27.5l-2.3,0c0,0.8,0,1.6,0.1,2.4l2.3-0.2C1682.2,29,1682.2,28.2,1682.2,27.5z M1741,9.2c-0.5-0.7-0.9-1.3-1.4-2l-1.9,1.4
          c0.5,0.6,0.9,1.2,1.3,1.8L1741,9.2z M1684.3,16.4l-2.2-0.9c-0.3,0.8-0.6,1.5-0.8,2.3l2.2,0.7C1683.8,17.9,1684,17.2,1684.3,16.4z
          M1732.6,0.6c-0.7-0.5-1.3-0.9-2-1.3l-1.2,2c0.6,0.4,1.3,0.8,1.9,1.2L1732.6,0.6z M1690.2,6.9l-1.7-1.6c-0.5,0.6-1.1,1.2-1.6,1.9
          l1.9,1.4C1689.2,8,1689.7,7.4,1690.2,6.9z M1721.7-4.6c-0.8-0.2-1.6-0.4-2.4-0.5l-0.4,2.3c0.7,0.1,1.5,0.3,2.2,0.5L1721.7-4.6z
          M1699.1,0l-1.1-2.1c-0.7,0.4-1.4,0.8-2.1,1.2l1.2,2C1697.8,0.8,1698.5,0.4,1699.1,0z M1709.6-5.5c-0.8,0.1-1.6,0.2-2.4,0.4
          l0.4,2.3c0.7-0.1,1.5-0.2,2.2-0.3L1709.6-5.5z M1727.6,520l-0.7-2.2c-0.7,0.2-1.4,0.4-2.2,0.6l0.6,2.3
          C1726.1,520.5,1726.8,520.3,1727.6,520z M1715.7,519.3c-0.8,0-1.5-0.1-2.2-0.2l-0.3,2.3c0.8,0.1,1.6,0.2,2.4,0.2L1715.7,519.3z
          M1738.2,514.2l-1.5-1.8c-0.6,0.5-1.2,0.9-1.8,1.4l1.3,1.9C1736.9,515.2,1737.6,514.7,1738.2,514.2z M1704.8,516.8
          c-0.7-0.3-1.4-0.6-2-1l-1.1,2.1c0.7,0.4,1.4,0.7,2.2,1.1L1704.8,516.8z M1746,505l-2-1.2c-0.4,0.7-0.8,1.3-1.2,1.9l1.9,1.3
          C1745.2,506.4,1745.6,505.7,1746,505z M1695.5,510.5c-0.5-0.5-1.1-1.1-1.6-1.6l-1.8,1.6c0.5,0.6,1.1,1.2,1.7,1.8L1695.5,510.5z
          M1750.1,493.6l-2.3-0.4c-0.1,0.7-0.3,1.5-0.4,2.2l2.3,0.5C1749.8,495.2,1750,494.4,1750.1,493.6z M1689,501.3
          c-0.3-0.7-0.6-1.4-0.9-2.1l-2.2,0.8c0.3,0.8,0.6,1.5,0.9,2.2L1689,501.3z M1749.8,481.6l-2.3,0.5c0.2,0.7,0.3,1.5,0.4,2.2l2.3-0.3
          C1750.1,483.2,1750,482.4,1749.8,481.6z M1749.7,481c-0.2-0.8-0.4-1.6-0.6-2.4l-2.2,0.7c0.2,0.7,0.4,1.4,0.6,2.2L1749.7,481z
          M1686.2,488.2l-2.3,0c0,0.8,0,1.6,0.1,2.4l2.3-0.2C1686.2,489.7,1686.2,488.9,1686.2,488.2z M1745,469.9c-0.5-0.7-0.9-1.3-1.4-2
          l-1.9,1.4c0.5,0.6,0.9,1.2,1.3,1.8L1745,469.9z M1688.3,477.1l-2.2-0.9c-0.3,0.8-0.6,1.5-0.8,2.3l2.2,0.7
          C1687.8,478.5,1688,477.8,1688.3,477.1z M1736.6,461.2c-0.7-0.5-1.3-0.9-2-1.3l-1.2,2c0.6,0.4,1.3,0.8,1.9,1.2L1736.6,461.2z
          M1694.2,467.6l-1.7-1.6c-0.5,0.6-1.1,1.2-1.6,1.9l1.9,1.4C1693.2,468.7,1693.7,468.1,1694.2,467.6z M1725.7,456.1
          c-0.8-0.2-1.6-0.4-2.4-0.5l-0.4,2.3c0.7,0.1,1.5,0.3,2.2,0.5L1725.7,456.1z M1703.1,460.7l-1.1-2.1c-0.7,0.4-1.4,0.8-2.1,1.2l1.2,2
          C1701.8,461.4,1702.4,461.1,1703.1,460.7z M1713.6,455.2c-0.8,0.1-1.6,0.2-2.4,0.3l0.4,2.3c0.7-0.1,1.5-0.2,2.2-0.3L1713.6,455.2z
          M1743.5,586.7l-0.6-2.3c-0.7,0.2-1.5,0.4-2.2,0.6l0.5,2.3C1742,587.1,1742.7,586.9,1743.5,586.7z M1731.5,586.8
          c-0.8,0.1-1.5,0.2-2.3,0.3l0.3,2.3c0.8-0.1,1.6-0.2,2.4-0.3L1731.5,586.8z M1754.7,583l-0.9-2.2c-0.7,0.3-1.4,0.6-2.2,0.8l0.8,2.2
          C1753.3,583.5,1754,583.3,1754.7,583z M1720,587.8c-0.8,0-1.5,0-2.3,0l0,2.3c0.8,0,1.6,0,2.4,0L1720,587.8z M1765.5,578l-1.1-2.1
          c-0.7,0.4-1.4,0.7-2.1,1.1l1.1,2.1C1764.1,578.7,1764.8,578.3,1765.5,578z M1708.4,587.4c-0.8-0.1-1.5-0.1-2.3-0.2l-0.3,2.3
          c0.8,0.1,1.6,0.2,2.4,0.2L1708.4,587.4z M1775.6,571.8l-1.3-1.9c-0.6,0.4-1.3,0.9-1.9,1.3l1.3,2
          C1774.3,572.7,1774.9,572.2,1775.6,571.8z M1697,585.7c-0.8-0.2-1.5-0.3-2.3-0.5l-0.5,2.3c0.8,0.2,1.5,0.4,2.3,0.5L1697,585.7z
          M1784.9,564.4l-1.6-1.8c-0.6,0.5-1.2,1-1.7,1.5l1.5,1.8C1783.7,565.4,1784.3,564.9,1784.9,564.4z M1685.8,582.7
          c-0.7-0.2-1.5-0.5-2.2-0.8l-0.8,2.2c0.7,0.3,1.5,0.5,2.2,0.8L1685.8,582.7z M1793.2,556l-1.8-1.6c-0.5,0.6-1,1.1-1.6,1.7l1.7,1.6
          C1792.2,557.2,1792.7,556.6,1793.2,556z M1675,578.4c-0.7-0.3-1.4-0.7-2.1-1l-1,2.1c0.7,0.4,1.4,0.7,2.1,1L1675,578.4z
          M1800.6,546.7l-1.9-1.3c-0.4,0.6-0.9,1.3-1.3,1.9l1.9,1.4C1799.7,548,1800.1,547.4,1800.6,546.7z M1664.9,572.9
          c-0.7-0.4-1.3-0.8-2-1.2l-1.3,2c0.7,0.4,1.3,0.9,2,1.3L1664.9,572.9z M1806.8,536.6l-2.1-1.1c-0.4,0.7-0.7,1.4-1.1,2l2,1.2
          C1806,538,1806.4,537.3,1806.8,536.6z M1655.4,566.3c-0.6-0.5-1.2-1-1.8-1.5l-1.5,1.8c0.6,0.5,1.2,1,1.8,1.5L1655.4,566.3z
          M1811.8,525.9l-2.2-0.9c-0.3,0.7-0.6,1.4-0.9,2.1l2.2,0.9C1811.2,527.4,1811.5,526.6,1811.8,525.9z M1646.7,558.6
          c-0.5-0.5-1.1-1.1-1.6-1.7l-1.7,1.6c0.5,0.6,1.1,1.1,1.7,1.7L1646.7,558.6z M1815.5,514.6l-2.3-0.6c-0.2,0.7-0.4,1.5-0.6,2.2
          l2.2,0.7C1815.1,516.2,1815.3,515.4,1815.5,514.6z M1639,549.9c-0.5-0.6-0.9-1.2-1.4-1.8l-1.9,1.4c0.5,0.6,1,1.3,1.4,1.9
          L1639,549.9z M1817.9,503l-2.3-0.3c-0.1,0.8-0.2,1.5-0.4,2.3l2.3,0.4C1817.7,504.6,1817.8,503.8,1817.9,503z M1632.4,540.4
          c-0.4-0.7-0.8-1.3-1.2-2l-2,1.2c0.4,0.7,0.8,1.4,1.2,2L1632.4,540.4z M1819,491.2l-2.3-0.1c0,0.8-0.1,1.5-0.1,2.3l2.3,0.1
          C1818.9,492.8,1818.9,492,1819,491.2z M1626.9,530.2c-0.3-0.7-0.6-1.4-1-2.1l-2.1,0.9c0.3,0.7,0.6,1.4,1,2.2L1626.9,530.2z
          M1818.6,479.4l-2.3,0.2c0.1,0.8,0.1,1.5,0.2,2.3l2.3-0.1C1818.7,480.9,1818.7,480.2,1818.6,479.4z M1622.7,519.4
          c-0.2-0.7-0.5-1.5-0.7-2.2l-2.2,0.7c0.2,0.8,0.5,1.5,0.7,2.3L1622.7,519.4z M1816.8,467.6l-2.3,0.5c0.2,0.8,0.3,1.5,0.4,2.3
          l2.3-0.4C1817.2,469.2,1817,468.4,1816.8,467.6z M1619.3,506l-2.3,0.4c0.1,0.8,0.3,1.6,0.4,2.3l2.3-0.5
          C1619.6,507.5,1619.4,506.7,1619.3,506z M1814.7,459.1c-0.2-0.8-0.5-1.5-0.7-2.3l-2.2,0.7c0.2,0.7,0.5,1.5,0.7,2.2L1814.7,459.1z
          M1617.9,494.5l-2.3,0.1c0,0.8,0.1,1.6,0.2,2.4l2.3-0.2C1618,496,1618,495.3,1617.9,494.5z M1810.6,447.9c-0.3-0.7-0.6-1.4-1-2.2
          l-2.1,1c0.3,0.7,0.6,1.4,0.9,2.1L1810.6,447.9z M1617.8,482.9l-2.3-0.1c0,0.8-0.1,1.6-0.1,2.4l2.3,0.1
          C1617.8,484.5,1617.8,483.7,1617.8,482.9z M1805.3,437.3c-0.4-0.7-0.8-1.4-1.2-2l-2,1.2c0.4,0.7,0.8,1.3,1.2,2L1805.3,437.3z
          M1619.2,471.4l-2.3-0.4c-0.1,0.8-0.3,1.6-0.4,2.4l2.3,0.3C1618.9,472.9,1619,472.2,1619.2,471.4z M1798.8,427.5
          c-0.5-0.6-1-1.3-1.4-1.9l-1.8,1.4c0.5,0.6,0.9,1.2,1.4,1.8L1798.8,427.5z M1621.8,460.1l-2.2-0.7c-0.2,0.8-0.4,1.5-0.6,2.3l2.3,0.6
          C1621.4,461.6,1621.6,460.9,1621.8,460.1z M1791.2,418.4c-0.5-0.6-1.1-1.1-1.6-1.7l-1.7,1.7c0.5,0.5,1.1,1.1,1.6,1.7L1791.2,418.4z
          M1625.7,449.2l-2.2-0.9c-0.3,0.7-0.6,1.5-0.9,2.2l2.2,0.9C1625.1,450.7,1625.4,449.9,1625.7,449.2z M1782.5,410.3
          c-0.6-0.5-1.2-1-1.8-1.5l-1.5,1.8c0.6,0.5,1.2,1,1.8,1.5L1782.5,410.3z M1630.9,438.9l-2-1.2c-0.4,0.7-0.8,1.4-1.2,2.1l2.1,1.1
          C1630.1,440.2,1630.5,439.5,1630.9,438.9z M1773,403.2c-0.7-0.4-1.3-0.9-2-1.3l-1.2,2c0.7,0.4,1.3,0.8,2,1.2L1773,403.2z
          M1637.2,429.2l-1.9-1.4c-0.5,0.6-0.9,1.3-1.4,1.9l1.9,1.4C1636.3,430.4,1636.8,429.8,1637.2,429.2z M1762.7,397.3
          c-0.7-0.4-1.4-0.7-2.1-1l-1,2.1c0.7,0.3,1.4,0.7,2.1,1L1762.7,397.3z M1644.7,420.3l-1.7-1.6c-0.5,0.6-1.1,1.2-1.6,1.7l1.7,1.6
          C1643.6,421.4,1644.1,420.8,1644.7,420.3z M1751.9,392.6c-0.7-0.3-1.5-0.5-2.2-0.8l-0.8,2.2c0.7,0.2,1.5,0.5,2.2,0.8L1751.9,392.6z
          M1653,412.3l-1.5-1.8c-0.6,0.5-1.2,1-1.8,1.5l1.6,1.8C1651.9,413.3,1652.5,412.8,1653,412.3z M1740.5,389.2
          c-0.8-0.2-1.5-0.4-2.3-0.5l-0.5,2.3c0.8,0.2,1.5,0.3,2.3,0.5L1740.5,389.2z M1662.3,405.4l-1.3-2c-0.7,0.4-1.3,0.9-2,1.3l1.3,1.9
          C1661,406.2,1661.7,405.8,1662.3,405.4z M1728.8,387.2c-0.8-0.1-1.6-0.2-2.4-0.2l-0.2,2.3c0.8,0.1,1.5,0.2,2.3,0.2L1728.8,387.2z
          M1672.3,399.6l-1.1-2.1c-0.7,0.4-1.4,0.7-2.1,1.1l1.1,2.1C1670.9,400.3,1671.6,399.9,1672.3,399.6z M1717,386.5
          c-0.8,0-1.6,0-2.4,0l0.1,2.3c0.8,0,1.5,0,2.3,0L1717,386.5z M1682.9,395l-0.8-2.2c-0.7,0.3-1.5,0.6-2.2,0.8l0.9,2.2
          C1681.5,395.5,1682.2,395.2,1682.9,395z M1705.1,387.3c-0.8,0.1-1.6,0.2-2.4,0.3l0.3,2.3c0.8-0.1,1.5-0.2,2.3-0.3L1705.1,387.3z
          M1694,391.6l-0.5-2.3c-0.8,0.2-1.5,0.4-2.3,0.6l0.6,2.3C1692.5,392,1693.3,391.8,1694,391.6z M1965.5,700.5l-0.7-2.2
          c-0.7,0.2-1.4,0.4-2.2,0.6l0.6,2.3C1964,701,1964.8,700.8,1965.5,700.5z M1953.7,699.8c-0.8,0-1.5-0.1-2.2-0.2l-0.3,2.3
          c0.8,0.1,1.6,0.2,2.4,0.2L1953.7,699.8z M1976.1,694.7l-1.5-1.8c-0.6,0.5-1.2,0.9-1.8,1.4l1.3,1.9
          C1974.8,695.7,1975.5,695.2,1976.1,694.7z M1942.7,697.3c-0.7-0.3-1.4-0.6-2-1l-1.1,2.1c0.7,0.4,1.4,0.7,2.2,1.1L1942.7,697.3z
          M1984,685.5l-2-1.2c-0.4,0.7-0.8,1.3-1.2,1.9l1.9,1.3C1983.1,686.9,1983.6,686.2,1984,685.5z M1933.4,691
          c-0.5-0.5-1.1-1.1-1.6-1.6l-1.8,1.6c0.5,0.6,1.1,1.2,1.7,1.8L1933.4,691z M1988,674.2l-2.3-0.4c-0.1,0.7-0.3,1.5-0.4,2.2l2.3,0.5
          C1987.7,675.8,1987.9,675,1988,674.2z M1926.9,681.8c-0.3-0.7-0.6-1.4-0.9-2.1l-2.2,0.8c0.3,0.8,0.6,1.5,0.9,2.2L1926.9,681.8z
          M1987.7,662.1l-2.3,0.5c0.2,0.7,0.3,1.5,0.4,2.2l2.3-0.3C1988,663.7,1987.9,662.9,1987.7,662.1z M1987.6,661.6
          c-0.2-0.8-0.4-1.6-0.6-2.4l-2.2,0.7c0.2,0.7,0.4,1.4,0.6,2.2L1987.6,661.6z M1924.1,668.7l-2.3,0c0,0.8,0,1.6,0.1,2.4l2.3-0.2
          C1924.1,670.2,1924.1,669.4,1924.1,668.7z M1982.9,650.4c-0.5-0.7-0.9-1.3-1.4-2l-1.9,1.4c0.5,0.6,0.9,1.2,1.3,1.8L1982.9,650.4z
          M1926.2,657.7l-2.2-0.9c-0.3,0.8-0.6,1.5-0.8,2.3l2.2,0.7C1925.7,659.1,1925.9,658.4,1926.2,657.7z M1974.5,641.8
          c-0.7-0.5-1.3-0.9-2-1.3l-1.2,2c0.6,0.4,1.3,0.8,1.9,1.2L1974.5,641.8z M1932.1,648.1l-1.7-1.6c-0.5,0.6-1.1,1.2-1.6,1.9l1.9,1.4
          C1931.1,649.2,1931.6,648.6,1932.1,648.1z M1963.6,636.6c-0.8-0.2-1.6-0.4-2.4-0.5l-0.4,2.3c0.7,0.1,1.5,0.3,2.2,0.5L1963.6,636.6z
          M1941,641.3l-1.1-2.1c-0.7,0.4-1.4,0.8-2.1,1.2l1.2,2C1939.7,642,1940.3,641.6,1941,641.3z M1951.5,635.7
          c-0.8,0.1-1.6,0.2-2.4,0.3l0.4,2.3c0.7-0.1,1.5-0.2,2.2-0.3L1951.5,635.7z M545.1,394.7L336,438.1L232.3,370L39,410.2l0.5,2.3
          l192.3-39.9l103.8,68.1L545.6,397L545.1,394.7z M527.9,674.2l-192.3,39.9l-103.8-68.1L21.8,689.7l0.5,2.3l209.1-43.4l103.8,68.1
          l193.3-40.1L527.9,674.2z M510.9,212.8l92.8-17.8l-0.4-2.3l-93.8,18l-53.2,78.5L378.8,304l0.4,2.3l78.4-15L510.9,212.8z
          M576.4,233.2l8.8,9.7l13.4-2.6l-8.8-9.7l4.6-12.3l-13.4,2.6L576.4,233.2z M557.6,236.8l8.8,9.7l13.4-2.6l-8.8-9.7l4.6-12.3
          l-13.4,2.6L557.6,236.8z M538.9,240.4l8.8,9.7l13.4-2.6l-8.8-9.7l4.6-12.3l-13.4,2.6L538.9,240.4z M520.1,244l8.8,9.7l13.4-2.6
          l-8.8-9.7l4.6-12.3l-13.4,2.6L520.1,244z M380.6,313c4.3-0.8,7.1-5,6.3-9.3c-0.8-4.3-5-7.1-9.3-6.3c-4.3,0.8-7.1,5-6.3,9.3
          C372.1,311,376.3,313.8,380.6,313z M40.8,419.1c4.3-0.9,7-5.1,6.2-9.4c-0.9-4.3-5.1-7-9.4-6.2c-4.3,0.9-7,5.1-6.2,9.4
          C32.3,417.2,36.5,420,40.8,419.1z M384.1,335.5c-0.7,0.1-1.5,0.2-2.2,0.3l0.2,2.3c0.8-0.1,1.6-0.2,2.4-0.3L384.1,335.5z
          M395.9,333.7l-1.2-2c-0.6,0.4-1.3,0.7-2,1.1l1,2.1C394.5,334.5,395.2,334.1,395.9,333.7z M372.9,335.3c-0.7-0.1-1.5-0.3-2.2-0.5
          l-0.6,2.3c0.8,0.2,1.6,0.4,2.4,0.6L372.9,335.3z M405,325.8l-1.8-1.5c-0.5,0.6-1,1.2-1.5,1.7l1.7,1.6
          C404,327.1,404.5,326.5,405,325.8z M362.5,331.2c-0.6-0.4-1.3-0.8-1.9-1.3l-1.4,1.9c0.7,0.5,1.3,0.9,2,1.4L362.5,331.2z
          M410.7,315.2l-2.2-0.7c-0.2,0.7-0.5,1.4-0.8,2.1l2.2,0.9C410.2,316.7,410.5,316,410.7,315.2z M354.2,323.5
          c-0.5-0.6-0.9-1.2-1.3-1.9l-2,1.3c0.4,0.7,0.9,1.4,1.4,2L354.2,323.5z M412.3,303.2l-2.3,0.1c0,0.8,0.1,1.5,0,2.3l2.3,0
          C412.4,304.8,412.4,304,412.3,303.2z M349.2,313.5c-0.2-0.7-0.4-1.4-0.5-2.2l-2.3,0.5c0.2,0.8,0.4,1.6,0.6,2.4L349.2,313.5z
          M348.2,308.6l-2.3,0.3c0.1,0.8,0.2,1.6,0.4,2.4l2.3-0.4C348.4,310,348.3,309.3,348.2,308.6z M410.4,293.7
          c-0.3-0.8-0.6-1.5-0.9-2.3l-2.1,0.9c0.3,0.7,0.6,1.4,0.8,2.1L410.4,293.7z M349,297.4l-2.3-0.6c-0.2,0.8-0.4,1.6-0.5,2.4l2.3,0.4
          C348.6,298.8,348.8,298.1,349,297.4z M404.3,283.3c-0.5-0.6-1.1-1.2-1.6-1.8l-1.7,1.6c0.5,0.5,1,1.1,1.5,1.7L404.3,283.3z
          M353.7,287.1l-1.9-1.3c-0.5,0.7-0.9,1.3-1.3,2l2,1.2C352.8,288.4,353.2,287.8,353.7,287.1z M395,275.7c-0.7-0.4-1.4-0.8-2.2-1.1
          l-1,2.1c0.7,0.3,1.4,0.6,2,1L395,275.7z M361.7,279.3l-1.3-1.9c-0.7,0.5-1.3,0.9-2,1.4l1.5,1.8C360.4,280.1,361,279.7,361.7,279.3z
          M383.5,271.9c-0.8-0.1-1.6-0.2-2.4-0.2l-0.1,2.3c0.8,0,1.5,0.1,2.2,0.2L383.5,271.9z M372,274.8l-0.5-2.3
          c-0.8,0.2-1.6,0.4-2.3,0.6l0.7,2.2C370.5,275.1,371.2,275,372,274.8z M533.7,705.8c-0.7,0.1-1.5,0.2-2.2,0.3l0.3,2.3
          c0.8-0.1,1.6-0.2,2.4-0.3L533.7,705.8z M545.4,703.9l-1.2-2c-0.6,0.4-1.3,0.8-2,1.1l1.1,2.1C544.1,704.7,544.8,704.3,545.4,703.9z
          M522.5,705.8c-0.7-0.1-1.5-0.3-2.2-0.5l-0.6,2.3c0.8,0.2,1.6,0.4,2.4,0.5L522.5,705.8z M554.5,695.8l-1.9-1.4
          c-0.5,0.6-0.9,1.2-1.4,1.7l1.7,1.6C553.5,697.1,554,696.5,554.5,695.8z M512,701.8c-0.6-0.4-1.3-0.8-1.9-1.2l-1.4,1.9
          c0.7,0.5,1.3,0.9,2,1.3L512,701.8z M560,685.1l-2.2-0.7c-0.2,0.7-0.5,1.4-0.7,2.1l2.2,0.9C559.5,686.6,559.8,685.9,560,685.1z
          M503.6,694.3c-0.5-0.6-0.9-1.2-1.3-1.8l-2,1.3c0.4,0.7,0.9,1.3,1.4,2L503.6,694.3z M561.4,673.1l-2.3,0.2c0.1,0.8,0.1,1.5,0.1,2.3
          l2.3,0C561.5,674.7,561.5,673.9,561.4,673.1z M498.5,684.3c-0.2-0.7-0.4-1.4-0.6-2.2l-2.3,0.5c0.2,0.8,0.4,1.6,0.6,2.3L498.5,684.3
          z M497.4,679.4l-2.3,0.3c0.1,0.8,0.2,1.6,0.4,2.4l2.3-0.5C497.7,680.9,497.5,680.1,497.4,679.4z M559.4,663.6
          c-0.3-0.8-0.6-1.5-0.9-2.2l-2.1,1c0.3,0.7,0.6,1.4,0.9,2.1L559.4,663.6z M498,668.2l-2.3-0.5c-0.2,0.8-0.3,1.6-0.5,2.4l2.3,0.4
          C497.7,669.7,497.8,668.9,498,668.2z M553.2,653.3c-0.5-0.6-1.1-1.2-1.7-1.8l-1.6,1.7c0.5,0.5,1.1,1.1,1.6,1.6L553.2,653.3z
          M502.5,657.9l-1.9-1.3c-0.5,0.7-0.9,1.4-1.3,2.1l2,1.2C501.7,659.2,502.1,658.5,502.5,657.9z M543.7,645.8
          c-0.7-0.4-1.4-0.7-2.2-1.1l-0.9,2.2c0.7,0.3,1.4,0.6,2,1L543.7,645.8z M510.4,649.9l-1.3-1.9c-0.7,0.5-1.3,1-1.9,1.5l1.5,1.8
          C509.2,650.8,509.8,650.3,510.4,649.9z M532.1,642.2c-0.8-0.1-1.6-0.2-2.4-0.2l-0.1,2.3c0.8,0,1.5,0.1,2.3,0.2L532.1,642.2z
          M520.6,645.3l-0.6-2.3c-0.8,0.2-1.6,0.4-2.3,0.7l0.7,2.2C519.2,645.7,519.9,645.4,520.6,645.3z M44.8,441.8
          c-0.7,0.1-1.5,0.2-2.2,0.3l0.3,2.3c0.8-0.1,1.6-0.2,2.4-0.4L44.8,441.8z M56.5,439.8l-1.2-2c-0.6,0.4-1.3,0.8-2,1.1l1.1,2.1
          C55.1,440.6,55.8,440.3,56.5,439.8z M33.5,441.8c-0.7-0.1-1.5-0.3-2.2-0.5l-0.6,2.3c0.8,0.2,1.6,0.4,2.4,0.5L33.5,441.8z
          M65.5,431.8l-1.9-1.4c-0.5,0.6-0.9,1.2-1.5,1.7l1.7,1.6C64.5,433.1,65,432.4,65.5,431.8z M23.1,437.8c-0.6-0.4-1.3-0.8-1.9-1.2
          l-1.4,1.9c0.7,0.5,1.3,0.9,2,1.3L23.1,437.8z M71.1,421.1l-2.2-0.7c-0.2,0.7-0.5,1.4-0.7,2.1l2.2,0.8
          C70.6,422.6,70.9,421.9,71.1,421.1z M14.7,430.3c-0.5-0.6-0.9-1.2-1.3-1.8l-2,1.3c0.4,0.7,0.9,1.3,1.4,2L14.7,430.3z M72.5,409.1
          l-2.3,0.2c0.1,0.8,0.1,1.5,0.1,2.3l2.3,0C72.6,410.7,72.5,409.9,72.5,409.1z M9.6,420.3c-0.2-0.7-0.4-1.4-0.6-2.2l-2.3,0.5
          c0.2,0.8,0.4,1.6,0.6,2.3L9.6,420.3z M8.5,415.4l-2.3,0.3c0.1,0.8,0.2,1.6,0.4,2.4l2.3-0.5C8.7,416.9,8.6,416.1,8.5,415.4z
          M70.4,399.6c-0.3-0.8-0.6-1.5-0.9-2.2l-2.1,1c0.3,0.7,0.6,1.4,0.9,2.1L70.4,399.6z M9,404.2l-2.3-0.5c-0.2,0.8-0.3,1.6-0.5,2.4
          l2.3,0.4C8.7,405.6,8.9,404.9,9,404.2z M64.2,389.3c-0.5-0.6-1.1-1.2-1.7-1.8l-1.6,1.7c0.5,0.5,1.1,1.1,1.6,1.6L64.2,389.3z
          M13.6,393.9l-1.9-1.3c-0.5,0.7-0.9,1.4-1.3,2.1l2,1.2C12.8,395.2,13.2,394.5,13.6,393.9z M54.7,381.8c-0.7-0.4-1.4-0.7-2.2-1.1
          l-0.9,2.2c0.7,0.3,1.4,0.6,2,1L54.7,381.8z M21.5,385.9l-1.3-1.9c-0.7,0.5-1.3,1-1.9,1.5l1.5,1.8C20.2,386.8,20.9,386.3,21.5,385.9
          z M43.2,378.2c-0.8-0.1-1.6-0.2-2.4-0.2l-0.1,2.3c0.8,0,1.5,0.1,2.3,0.2L43.2,378.2z M31.7,381.3l-0.6-2.3
          c-0.8,0.2-1.6,0.4-2.3,0.7l0.7,2.2C30.2,381.6,31,381.4,31.7,381.3z M547.8,402.7c4.3-0.9,7-5.1,6.2-9.4c-0.9-4.3-5.1-7-9.4-6.2
          c-4.3,0.9-7,5.1-6.2,9.4C539.3,400.8,543.5,403.6,547.8,402.7z M551.8,425.4c-0.7,0.1-1.5,0.2-2.2,0.3l0.3,2.3
          c0.8-0.1,1.6-0.2,2.4-0.4L551.8,425.4z M563.5,423.4l-1.2-2c-0.6,0.4-1.3,0.8-2,1.1l1.1,2.1C562.1,424.2,562.8,423.8,563.5,423.4z
          M540.5,425.4c-0.7-0.1-1.5-0.3-2.2-0.5l-0.6,2.3c0.8,0.2,1.6,0.4,2.4,0.5L540.5,425.4z M572.5,415.4l-1.9-1.4
          c-0.5,0.6-0.9,1.2-1.5,1.7l1.7,1.6C571.5,416.6,572,416,572.5,415.4z M530.1,421.3c-0.6-0.4-1.3-0.8-1.9-1.2l-1.4,1.9
          c0.7,0.5,1.3,0.9,2,1.3L530.1,421.3z M578.1,404.7l-2.2-0.7c-0.2,0.7-0.5,1.4-0.7,2.1l2.2,0.8C577.6,406.2,577.8,405.4,578.1,404.7
          z M521.7,413.9c-0.5-0.6-0.9-1.2-1.3-1.8l-2,1.3c0.4,0.7,0.9,1.3,1.4,2L521.7,413.9z M579.5,392.7l-2.3,0.2
          c0.1,0.8,0.1,1.5,0.1,2.3l2.3,0C579.6,394.3,579.5,393.5,579.5,392.7z M516.5,403.9c-0.2-0.7-0.4-1.4-0.6-2.2l-2.3,0.5
          c0.2,0.8,0.4,1.6,0.6,2.3L516.5,403.9z M515.5,399l-2.3,0.3c0.1,0.8,0.2,1.6,0.4,2.4l2.3-0.5C515.7,400.5,515.6,399.7,515.5,399z
          M577.4,383.2c-0.3-0.8-0.6-1.5-0.9-2.2l-2.1,1c0.3,0.7,0.6,1.4,0.9,2.1L577.4,383.2z M516,387.8l-2.3-0.5
          c-0.2,0.8-0.3,1.6-0.5,2.4l2.3,0.4C515.7,389.2,515.9,388.5,516,387.8z M571.2,372.8c-0.5-0.6-1.1-1.2-1.7-1.8l-1.6,1.7
          c0.5,0.5,1.1,1.1,1.6,1.6L571.2,372.8z M520.6,377.5l-1.9-1.3c-0.5,0.7-0.9,1.4-1.3,2.1l2,1.2C519.7,378.7,520.2,378.1,520.6,377.5
          z M561.7,365.4c-0.7-0.4-1.4-0.7-2.2-1.1l-0.9,2.1c0.7,0.3,1.4,0.6,2,1L561.7,365.4z M528.5,369.5l-1.3-1.9c-0.7,0.5-1.3,1-1.9,1.5
          l1.5,1.8C527.2,370.4,527.8,369.9,528.5,369.5z M550.2,361.8c-0.8-0.1-1.6-0.2-2.4-0.2l-0.1,2.3c0.8,0,1.5,0.1,2.3,0.2L550.2,361.8
          z M538.7,364.8l-0.6-2.3c-0.8,0.2-1.6,0.4-2.3,0.7l0.7,2.2C537.2,365.2,537.9,365,538.7,364.8z M1635.2,821.5l34.8-7.4l-7.4-34.8
          l-34.8,7.4L1635.2,821.5z M1585.4,832.1l34.8-7.4l-7.4-34.8l-34.8,7.4L1585.4,832.1z M1493.9,851.6l76.6-16.3l-7.4-34.8l-76.6,16.3
          L1493.9,851.6z M1282.7,203.4c-0.8,2.6-3.3,4.1-5.6,3.4c-2.3-0.7-3.5-3.3-2.7-5.9c0.8-2.6,3.3-4.1,5.6-3.4
          C1282.3,198.2,1283.5,200.8,1282.7,203.4z M77.6,525.4c-4.3,0.8-7.1,5-6.3,9.3c0.8,4.3,5,7.1,9.3,6.3s7.1-5,6.3-9.3
          C86.1,527.4,81.9,524.6,77.6,525.4z M80.8,533.2l-192.9,37l-102.7-69.6L-425.5,541l0.4,2.3l209.7-40.2l102.7,69.6l193.9-37.2
          L80.8,533.2z M-423.8,550c4.3-0.8,7.1-5,6.3-9.3c-0.8-4.3-5-7.1-9.3-6.3s-7.1,5-6.3,9.3C-432.2,548-428.1,550.8-423.8,550z"/>
        <polygon class="st1" points="328.1,504.2 420.7,484.9 420.2,482.6 326.7,502.1 274.7,581.4 197.4,597.4 
          197.9,599.7 276.1,583.5 	"/>
        <polygon id="XMLID_557_" class="st1" points="182.9,755.4 174,745.8 160.6,748.6 169.6,758.1 165.1,770.5 178.5,767.7 	"/>
        <polygon id="XMLID_555_" class="st1" points="201.6,751.5 192.7,741.9 179.3,744.7 188.3,754.3 183.8,766.6 197.2,763.8 	"/>
        <polygon id="XMLID_553_" class="st1" points="220.3,747.6 211.4,738 198,740.8 206.9,750.4 202.5,762.7 215.9,759.9 	"/>
        <polygon id="XMLID_551_" class="st1" points="239,743.7 230.1,734.2 216.7,736.9 225.6,746.5 221.2,758.8 234.6,756.1 	"/>
        <path id="XMLID_548_" class="st1" d="M201.9,605.8c4.3-0.9,7-5.1,6.2-9.4c-0.9-4.3-5.1-7-9.4-6.2c-4.3,0.9-7,5.1-6.2,9.4
          C193.4,603.9,197.6,606.7,201.9,605.8z"/>
        <path id="XMLID_546_" class="st1" d="M205.9,628.5c-0.7,0.1-1.5,0.2-2.2,0.3l0.3,2.3c0.8-0.1,1.6-0.2,2.4-0.4L205.9,628.5z"/>
        <path id="XMLID_545_" class="st1" d="M217.6,626.5l-1.2-2c-0.6,0.4-1.3,0.8-2,1.1l1.1,2.1C216.2,627.4,216.9,627,217.6,626.5z"/>
        <path id="XMLID_544_" class="st1" d="M194.7,628.5c-0.7-0.1-1.5-0.3-2.2-0.5l-0.6,2.3c0.8,0.2,1.6,0.4,2.4,0.5L194.7,628.5z"/>
        <path id="XMLID_543_" class="st1" d="M226.6,618.5l-1.9-1.4c-0.5,0.6-0.9,1.2-1.5,1.7l1.7,1.6C225.6,619.8,226.1,619.1,226.6,618.5
          z"/>
        <path id="XMLID_542_" class="st1" d="M184.2,624.5c-0.6-0.4-1.3-0.8-1.9-1.2l-1.4,1.9c0.7,0.5,1.3,0.9,2,1.3L184.2,624.5z"/>
        <path id="XMLID_541_" class="st1" d="M232.2,607.8l-2.2-0.7c-0.2,0.7-0.5,1.4-0.7,2.1l2.2,0.8C231.7,609.3,232,608.6,232.2,607.8z"
          />
        <path id="XMLID_540_" class="st1" d="M175.8,617c-0.5-0.6-0.9-1.2-1.3-1.8l-2,1.3c0.4,0.7,0.9,1.3,1.4,2L175.8,617z"/>
        <path id="XMLID_539_" class="st1" d="M233.6,595.8l-2.3,0.2c0.1,0.8,0.1,1.5,0.1,2.3l2.3,0C233.7,597.4,233.6,596.6,233.6,595.8z"
          />
        <path id="XMLID_538_" class="st1" d="M170.7,607c-0.2-0.7-0.4-1.4-0.6-2.2l-2.3,0.5c0.2,0.8,0.4,1.6,0.6,2.3L170.7,607z"/>
        <path id="XMLID_537_" class="st1" d="M169.6,602.1l-2.3,0.3c0.1,0.8,0.2,1.6,0.4,2.4l2.3-0.5C169.8,603.6,169.7,602.8,169.6,602.1z
          "/>
        <path id="XMLID_536_" class="st1" d="M231.5,586.3c-0.3-0.8-0.6-1.5-0.9-2.2l-2.1,1c0.3,0.7,0.6,1.4,0.9,2.1L231.5,586.3z"/>
        <path id="XMLID_535_" class="st1" d="M170.2,590.9l-2.3-0.5c-0.2,0.8-0.3,1.6-0.5,2.4l2.3,0.4C169.8,592.4,170,591.6,170.2,590.9z"
          />
        <path id="XMLID_534_" class="st1" d="M225.3,576c-0.5-0.6-1.1-1.2-1.7-1.8l-1.6,1.7c0.5,0.5,1.1,1.1,1.6,1.6L225.3,576z"/>
        <path id="XMLID_533_" class="st1" d="M174.7,580.6l-1.9-1.3c-0.5,0.7-0.9,1.4-1.3,2.1l2,1.2C173.9,581.9,174.3,581.2,174.7,580.6z"
          />
        <path id="XMLID_532_" class="st1" d="M215.8,568.5c-0.7-0.4-1.4-0.7-2.2-1.1l-0.9,2.2c0.7,0.3,1.4,0.6,2,1L215.8,568.5z"/>
        <path id="XMLID_531_" class="st1" d="M182.6,572.6l-1.3-1.9c-0.7,0.5-1.3,1-1.9,1.5l1.5,1.8C181.4,573.5,182,573,182.6,572.6z"/>
        <path id="XMLID_530_" class="st1" d="M204.3,564.9c-0.8-0.1-1.6-0.2-2.4-0.2l-0.1,2.3c0.8,0,1.5,0.1,2.3,0.2L204.3,564.9z"/>
        <path id="XMLID_529_" class="st1" d="M192.8,568l-0.6-2.3c-0.8,0.2-1.6,0.4-2.3,0.7l0.7,2.2C191.3,568.4,192.1,568.1,192.8,568z"/>
        <path id="XMLID_526_" class="st1" d="M226.3,696.4l-0.6-2.3c-0.7,0.2-1.5,0.4-2.2,0.6l0.5,2.3C224.8,696.8,225.6,696.6,226.3,696.4
          z"/>
        <path id="XMLID_525_" class="st1" d="M214.4,696.5c-0.8,0.1-1.5,0.2-2.3,0.3l0.3,2.3c0.8-0.1,1.6-0.2,2.4-0.3L214.4,696.5z"/>
        <path id="XMLID_524_" class="st1" d="M237.6,692.8l-0.9-2.2c-0.7,0.3-1.4,0.6-2.2,0.8l0.8,2.2C236.1,693.3,236.9,693.1,237.6,692.8
          z"/>
        <path id="XMLID_523_" class="st1" d="M202.8,697.5c-0.8,0-1.5,0-2.3,0l0,2.3c0.8,0,1.6,0,2.4,0L202.8,697.5z"/>
        <path id="XMLID_522_" class="st1" d="M248.4,687.8l-1.1-2.1c-0.7,0.4-1.4,0.7-2.1,1.1l1.1,2.1C247,688.5,247.7,688.2,248.4,687.8z"
          />
        <path id="XMLID_521_" class="st1" d="M191.3,697.1c-0.8-0.1-1.5-0.2-2.3-0.2l-0.3,2.3c0.8,0.1,1.6,0.2,2.4,0.2L191.3,697.1z"/>
        <path id="XMLID_520_" class="st1" d="M258.5,681.6l-1.3-1.9c-0.6,0.4-1.3,0.9-1.9,1.3l1.3,2C257.2,682.5,257.8,682.1,258.5,681.6z"
          />
        <path id="XMLID_519_" class="st1" d="M179.8,695.4c-0.8-0.2-1.5-0.3-2.3-0.5l-0.5,2.3c0.8,0.2,1.5,0.4,2.3,0.5L179.8,695.4z"/>
        <path id="XMLID_518_" class="st1" d="M267.8,674.3l-1.6-1.8c-0.6,0.5-1.2,1-1.7,1.5l1.5,1.8C266.6,675.3,267.2,674.8,267.8,674.3z"
          />
        <path id="XMLID_517_" class="st1" d="M168.6,692.3c-0.7-0.2-1.5-0.5-2.2-0.8l-0.8,2.2c0.7,0.3,1.5,0.5,2.2,0.8L168.6,692.3z"/>
        <path id="XMLID_516_" class="st1" d="M276.2,665.9l-1.7-1.6c-0.5,0.6-1,1.1-1.6,1.7l1.7,1.6C275.1,667.1,275.6,666.5,276.2,665.9z"
          />
        <path id="XMLID_515_" class="st1" d="M157.9,688c-0.7-0.3-1.4-0.7-2.1-1l-1.1,2.1c0.7,0.4,1.4,0.7,2.1,1L157.9,688z"/>
        <path id="XMLID_514_" class="st1" d="M283.5,656.7l-1.9-1.4c-0.4,0.6-0.9,1.3-1.4,1.9l1.9,1.4C282.6,657.9,283.1,657.3,283.5,656.7
          z"/>
        <path id="XMLID_513_" class="st1" d="M147.7,682.4c-0.7-0.4-1.3-0.8-2-1.2l-1.3,2c0.7,0.4,1.3,0.9,2,1.3L147.7,682.4z"/>
        <path id="XMLID_512_" class="st1" d="M289.8,646.6l-2.1-1.1c-0.4,0.7-0.7,1.4-1.1,2l2,1.2C289,648,289.4,647.3,289.8,646.6z"/>
        <path id="XMLID_511_" class="st1" d="M138.3,675.7c-0.6-0.5-1.2-1-1.8-1.5l-1.5,1.8c0.6,0.5,1.2,1,1.8,1.5L138.3,675.7z"/>
        <path id="XMLID_510_" class="st1" d="M294.8,635.9l-2.2-0.9c-0.3,0.7-0.6,1.4-0.9,2.1l2.2,0.9C294.2,637.3,294.5,636.6,294.8,635.9
          z"/>
        <path id="XMLID_509_" class="st1" d="M129.7,668c-0.5-0.5-1.1-1.1-1.6-1.7l-1.7,1.6c0.5,0.6,1.1,1.1,1.6,1.7L129.7,668z"/>
        <path id="XMLID_508_" class="st1" d="M298.6,624.6l-2.3-0.6c-0.2,0.7-0.4,1.5-0.6,2.2l2.2,0.7C298.2,626.2,298.4,625.4,298.6,624.6
          z"/>
        <path id="XMLID_507_" class="st1" d="M122,659.3c-0.5-0.6-0.9-1.2-1.4-1.8l-1.9,1.4c0.5,0.6,1,1.3,1.4,1.9L122,659.3z"/>
        <path id="XMLID_506_" class="st1" d="M301,613l-2.3-0.3c-0.1,0.8-0.2,1.5-0.4,2.3l2.3,0.4C300.8,614.6,300.9,613.8,301,613z"/>
        <path id="XMLID_505_" class="st1" d="M115.4,649.8c-0.4-0.7-0.8-1.3-1.2-2l-2,1.2c0.4,0.7,0.8,1.4,1.2,2L115.4,649.8z"/>
        <path id="XMLID_504_" class="st1" d="M302.1,601.2l-2.3-0.1c0,0.8-0.1,1.5-0.1,2.3l2.3,0.1C302,602.8,302.1,602,302.1,601.2z"/>
        <path id="XMLID_503_" class="st1" d="M110,639.6c-0.3-0.7-0.6-1.4-0.9-2.1l-2.2,0.9c0.3,0.7,0.6,1.5,1,2.2L110,639.6z"/>
        <path id="XMLID_502_" class="st1" d="M301.8,589.4l-2.3,0.2c0.1,0.8,0.1,1.5,0.2,2.3l2.3-0.2C301.9,590.9,301.8,590.2,301.8,589.4z
          "/>
        <path id="XMLID_501_" class="st1" d="M105.8,628.8c-0.2-0.7-0.5-1.5-0.7-2.2l-2.2,0.7c0.2,0.8,0.5,1.5,0.7,2.3L105.8,628.8z"/>
        <path id="XMLID_500_" class="st1" d="M300.1,577.6l-2.3,0.5c0.2,0.8,0.3,1.5,0.4,2.3l2.3-0.4C300.4,579.2,300.2,578.4,300.1,577.6z
          "/>
        <path id="XMLID_499_" class="st1" d="M102.5,616l-2.3,0.4c0.1,0.8,0.3,1.6,0.5,2.3l2.3-0.5C102.8,617.5,102.6,616.7,102.5,616z"/>
        <path id="XMLID_498_" class="st1" d="M297.7,568.4c-0.2-0.8-0.5-1.5-0.7-2.3l-2.2,0.7c0.2,0.7,0.5,1.5,0.7,2.2L297.7,568.4z"/>
        <path id="XMLID_497_" class="st1" d="M101.1,604.5l-2.3,0.2c0.1,0.8,0.1,1.6,0.2,2.4l2.3-0.2C101.2,606,101.1,605.3,101.1,604.5z"
          />
        <path id="XMLID_496_" class="st1" d="M293.7,557.3c-0.3-0.7-0.6-1.4-1-2.2l-2.1,1c0.3,0.7,0.6,1.4,0.9,2.1L293.7,557.3z"/>
        <path id="XMLID_495_" class="st1" d="M101,592.9l-2.3-0.1c0,0.8-0.1,1.6-0.1,2.4l2.3,0.1C100.9,594.4,100.9,593.7,101,592.9z"/>
        <path id="XMLID_494_" class="st1" d="M288.3,546.8c-0.4-0.7-0.8-1.4-1.2-2l-2,1.2c0.4,0.7,0.8,1.3,1.2,2L288.3,546.8z"/>
        <path id="XMLID_493_" class="st1" d="M102.2,581.4l-2.3-0.4c-0.1,0.8-0.3,1.6-0.4,2.3l2.3,0.3C102,582.9,102.1,582.2,102.2,581.4z"
          />
        <path id="XMLID_492_" class="st1" d="M281.7,536.9c-0.5-0.6-1-1.3-1.4-1.9l-1.8,1.5c0.5,0.6,0.9,1.2,1.4,1.8L281.7,536.9z"/>
        <path id="XMLID_491_" class="st1" d="M104.9,570.1l-2.3-0.7c-0.2,0.8-0.4,1.5-0.6,2.3l2.3,0.6C104.4,571.6,104.6,570.8,104.9,570.1
          z"/>
        <path id="XMLID_490_" class="st1" d="M274.1,527.8c-0.5-0.6-1.1-1.1-1.7-1.7l-1.7,1.7c0.5,0.5,1.1,1.1,1.6,1.7L274.1,527.8z"/>
        <path id="XMLID_489_" class="st1" d="M108.8,559.2l-2.2-0.9c-0.3,0.7-0.6,1.5-0.9,2.2l2.2,0.9C108.2,560.6,108.5,559.9,108.8,559.2
          z"/>
        <path id="XMLID_488_" class="st1" d="M265.4,519.8c-0.6-0.5-1.2-1-1.8-1.5l-1.5,1.8c0.6,0.5,1.2,1,1.8,1.5L265.4,519.8z"/>
        <path id="XMLID_487_" class="st1" d="M113.9,548.8l-2-1.2c-0.4,0.7-0.8,1.4-1.2,2.1l2.1,1.1C113.1,550.2,113.5,549.5,113.9,548.8z"
          />
        <path id="XMLID_486_" class="st1" d="M255.9,512.7c-0.7-0.4-1.3-0.9-2-1.3l-1.2,2c0.7,0.4,1.3,0.8,2,1.2L255.9,512.7z"/>
        <path id="XMLID_485_" class="st1" d="M120.2,539.1l-1.9-1.4c-0.5,0.6-0.9,1.3-1.4,1.9l1.9,1.3C119.3,540.4,119.7,539.7,120.2,539.1
          z"/>
        <path id="XMLID_484_" class="st1" d="M245.6,506.8c-0.7-0.4-1.4-0.7-2.1-1l-1,2.1c0.7,0.3,1.4,0.7,2.1,1L245.6,506.8z"/>
        <path id="XMLID_483_" class="st1" d="M127.6,530.2l-1.7-1.6c-0.5,0.6-1.1,1.2-1.6,1.8l1.8,1.6C126.5,531.3,127.1,530.8,127.6,530.2
          z"/>
        <path id="XMLID_482_" class="st1" d="M234.7,502.2c-0.7-0.3-1.5-0.5-2.2-0.8l-0.7,2.2c0.7,0.2,1.5,0.5,2.2,0.8L234.7,502.2z"/>
        <path id="XMLID_481_" class="st1" d="M135.9,522.2l-1.5-1.8c-0.6,0.5-1.2,1-1.8,1.6l1.6,1.8C134.8,523.2,135.4,522.7,135.9,522.2z"
          />
        <path id="XMLID_480_" class="st1" d="M223.3,498.8c-0.8-0.2-1.5-0.3-2.3-0.5l-0.5,2.3c0.8,0.2,1.5,0.3,2.3,0.5L223.3,498.8z"/>
        <path id="XMLID_479_" class="st1" d="M145.2,515.2l-1.3-2c-0.7,0.4-1.3,0.9-2,1.3l1.3,1.9C143.9,516.1,144.5,515.7,145.2,515.2z"/>
        <path id="XMLID_478_" class="st1" d="M211.6,496.8c-0.8-0.1-1.6-0.2-2.4-0.2l-0.2,2.3c0.8,0.1,1.5,0.1,2.3,0.2L211.6,496.8z"/>
        <path id="XMLID_477_" class="st1" d="M155.2,509.4l-1.1-2.1c-0.7,0.4-1.4,0.7-2.1,1.1l1.1,2.1C153.8,510.1,154.5,509.7,155.2,509.4
          z"/>
        <path id="XMLID_476_" class="st1" d="M199.8,496.2c-0.8,0-1.6,0-2.4,0l0.1,2.3c0.8,0,1.5,0,2.3,0L199.8,496.2z"/>
        <path id="XMLID_475_" class="st1" d="M165.8,504.7l-0.8-2.2c-0.7,0.3-1.5,0.6-2.2,0.8l0.9,2.2C164.3,505.3,165.1,505,165.8,504.7z"
          />
        <path id="XMLID_474_" class="st1" d="M188,497c-0.8,0.1-1.6,0.2-2.4,0.3l0.3,2.3c0.8-0.1,1.5-0.2,2.3-0.3L188,497z"/>
        <path id="XMLID_473_" class="st1" d="M176.9,501.4l-0.6-2.3c-0.8,0.2-1.5,0.4-2.3,0.6l0.6,2.3C175.4,501.8,176.1,501.6,176.9,501.4
          z"/>
        <polygon id="XMLID_469_" class="st1" points="1969.3,317.8 1984,333.5 2006,329 1991.3,313.3 1998.5,293 1976.6,297.6 	"/>
        <polygon id="XMLID_467_" class="st1" points="1938.6,324.2 1953.3,339.9 1975.3,335.4 1960.6,319.7 1967.8,299.4 1945.9,304 	"/>
        <polygon id="XMLID_465_" class="st1" points="1908,330.6 1922.7,346.3 1944.6,341.7 1929.9,326 1937.2,305.8 1915.2,310.3 	"/>
        <polygon id="XMLID_463_" class="st1" points="1877.3,337 1892,352.6 1913.9,348.1 1899.2,332.4 1906.5,312.1 1884.5,316.7 	"/>
        
          <rect id="XMLID_460_" x="1315.7" y="108.6" transform="matrix(-0.9781 0.2081 -0.2081 -0.9781 2647.1953 -41.082)" class="st1" width="20.2" height="20.2"/>
        
          <rect id="XMLID_459_" x="1287.4" y="114.6" transform="matrix(-0.9781 0.2081 -0.2081 -0.9781 2592.5244 -23.2994)" class="st1" width="20.2" height="20.2"/>
        
          <rect id="XMLID_458_" x="1235.1" y="123.2" transform="matrix(-0.9781 0.2081 -0.2081 -0.9781 2514.9094 1.9513)" class="st1" width="44.5" height="20.2"/>
        
          <rect id="XMLID_456_" x="585.4" y="277.1" transform="matrix(0.9761 -0.2174 0.2174 0.9761 -48.3658 136.5526)" class="st1" width="21.9" height="21.9"/>
        
          <rect id="XMLID_455_" x="616" y="270.3" transform="matrix(0.9761 -0.2174 0.2174 0.9761 -46.1557 143.0376)" class="st1" width="21.9" height="21.9"/>
        
          <rect id="XMLID_454_" x="646.2" y="260.7" transform="matrix(0.9761 -0.2174 0.2174 0.9761 -43.0163 152.2357)" class="st1" width="48.2" height="21.9"/>
      </g>
      <g>
        <path class="st1" d="M-18.1,373.8c-15.9,34.3-1,75,33.3,90.8c34.3,15.9,75,1,90.8-33.3c15.9-34.3,1-75-33.3-90.8
          C38.4,324.6-2.2,339.5-18.1,373.8z" :style="{fill: showClass === 1 ? '#3FB2AA' : ''}" />
        <path class="st2" d="M73.2,374.3l-4.5-21.5c-0.2-1-1.2-1.6-2.1-1.4l-15.5,3.3c-1,0.2-1.6,1.2-1.4,2.1l0.5,2.4L34,348.6
          c-0.8-0.5-2-0.3-2.5,0.5l-37.5,57.5c-0.4,0.6-0.4,1.4,0,2c0.4,0.6,1.2,0.9,1.9,0.8l12.7-2.7l9.5,45.4c0.2,1,1.2,1.6,2.1,1.4
          l66.2-13.9c1-0.2,1.6-1.2,1.4-2.1l-9.5-45.4l12.7-2.7c0.7-0.2,1.3-0.7,1.4-1.4c0.1-0.7-0.2-1.5-0.8-1.9L73.2,374.3z M45.5,413.1
          c-3.9,0.7-8,0.3-11.8-1.2c-6.7-2.7-11.6-8.7-12.9-15.8c5.5-3.8,12.5-4.9,18.9-2.8c0,0,0,0,0,0c-0.1,0.8-0.2,1.6-0.2,2.4
          c0,0.2,0,0.3,0,0.5c0,0.8,0,1.6,0,2.3c0,0.1,0,0.2,0,0.3c0.1,0.7,0.2,1.5,0.3,2.2c0,0.1,0,0.2,0,0.3c0,0.2,0.1,0.4,0.1,0.6L28,397
          c-0.9-0.4-2,0.1-2.4,1c-0.4,0.9,0.1,2,1,2.4l14.8,6c0,0,0,0,0,0.1c0.3,0.7,0.6,1.4,1,2c0.1,0.1,0.1,0.2,0.2,0.3
          c0.4,0.7,0.8,1.3,1.2,2c0.1,0.1,0.2,0.3,0.3,0.4C44.5,411.8,45,412.4,45.5,413.1C45.5,413.1,45.5,413.1,45.5,413.1z M55.7,381.9
          c-1-0.2-1.9,0.4-2.1,1.4l-5.6,26.9c-0.3-0.4-0.6-0.8-0.9-1.2c-0.2-0.3-0.5-0.7-0.7-1c-0.3-0.4-0.5-0.9-0.7-1.3
          c-0.2-0.4-0.4-0.7-0.6-1.1c-0.2-0.5-0.4-0.9-0.6-1.4c-0.1-0.4-0.3-0.7-0.4-1.1c-0.2-0.5-0.3-1-0.4-1.5c-0.1-0.4-0.2-0.7-0.3-1.1
          c-0.1-0.5-0.1-1.1-0.2-1.6c0-0.4-0.1-0.7-0.1-1.1c0-0.6,0-1.2,0-1.8c0-0.3,0-0.6,0-0.9c0.1-0.8,0.2-1.6,0.3-2.3
          c0-0.1,0-0.3,0.1-0.4c0,0,0,0,0,0c1.5-7.1,6.5-13,13.2-15.6c5.1,5.1,7.4,12.5,5.9,19.5c-1.3,6.3-5.5,11.7-11.2,14.6l5.6-26.9
          C57.3,383.1,56.7,382.1,55.7,381.9z M75.7,388.9c-1,0.2-1.6,1.2-1.4,2.1l9.5,45.4l-27.5,5.8l-5.7-26.9c7.9-3,13.9-9.9,15.6-18.2
          c1.8-8.7-1.2-17.8-7.8-23.7c-0.5-0.4-1.2-0.6-1.8-0.4c-7.8,2.6-13.8,8.8-16.1,16.6c-7.7-2.4-16.3-0.9-22.8,4.1
          c-0.5,0.4-0.8,1-0.7,1.7c1.2,8.8,7.1,16.4,15.3,19.7c4.6,1.9,9.7,2.3,14.5,1.3c0.1,0,0.2-0.1,0.3-0.1l5.6,26.6l-31.6,6.6l-9.5-45.4
          c-0.2-1-1.2-1.6-2.1-1.4L-0.7,405l34.2-52.3l18.4,12c0.6,0.4,1.4,0.4,2,0c0.6-0.4,0.9-1.2,0.8-1.9l-1-5l12-2.5l4.3,20.5
          c0.1,0.5,0.4,0.9,0.8,1.1l15.2,9.9L75.7,388.9z"/>
      </g>
      <g>
        <path class="st1" d="M1648.6,457c-18,38.9-1.1,85.1,37.8,103.1c38.9,18,85.1,1.1,103.1-37.8c18-38.9,1.1-85.1-37.8-103.1
          C1712.8,401.1,1666.6,418,1648.6,457z" :style="{fill: showClass === 1 ? '#3FB2AA' : ''}" />
        <g>
          <path class="st2" d="M1722.2,525l-10.7,9.6c-1.9,1.7-4.7,1.5-6.4-0.4c-1.7-1.9-1.5-4.7,0.3-6.4l0,0l6.2-5.5
            c0.6-0.6-0.5-0.6-1.1-1.3c-0.6-0.6-0.3-1.6-1-1l-6.2,5.5l0,0l0,0c0,0,0,0,0,0l-3.1,2.8l-0.1,0l0,0v0c-0.9,0.8-2.1,1.2-3.3,1.2
            c-1.2-0.1-2.3-0.6-3.1-1.5c-0.8-0.9-1.2-2.1-1.2-3.3c0.1-1.2,0.6-2.3,1.5-3.1c0,0,0,0,0,0l4.2-3.7c0.6-0.6-0.2-0.3-0.8-0.9
            c-0.6-0.6-0.6-1.9-1.2-1.4l-4.2,3.7c0,0,0,0,0,0c-1.9,1.7-4.7,1.5-6.4-0.3c-0.8-0.9-1.2-2.1-1.2-3.3c0.1-1,0.5-2,1.2-2.8l-3.1-1
            c-0.7,1.1-1.1,2.3-1.1,3.6c-0.1,2,0.6,4,1.9,5.5c1.6,1.8,4,2.7,6.3,2.5c-0.1,0.3-0.1,0.7-0.1,1.1c-0.1,2,0.6,4,1.9,5.5
            c1.3,1.5,3.2,2.4,5.2,2.5c1.5,0.1,2.9-0.3,4.1-1c0.1,1.7,0.7,3.3,1.9,4.6c1.9,2.1,4.6,2.9,7.2,2.4c1.3-0.3,2.5-0.8,3.5-1.8
            l12-10.8L1722.2,525z"/>
          <g>
            <path class="st3" d="M1704.8,478.3c-1,0.2-2.1,0.3-3.2,0.1c-2.7-0.4-5.1-2-6.5-4.4c-1.4-2.3-1.6-5-0.8-7.4l-8.3-2.7l-14.1,43.1
              l70.3,23c2.4,0.8,4.9-0.5,5.7-2.9c0.4-1.1,0.3-2.4-0.3-3.5c-0.5-1.1-1.5-1.9-2.6-2.3c0,0,0,0,0,0l-24.7-8.1
              c-0.5-0.2-0.9-0.6-1-1.1c-0.1-0.3,0-0.5,0-0.8c0.3-0.8,1.1-1.2,1.9-1l24.7,8.1c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0.1l5.3,1.7
              c2.4,0.8,4.9-0.5,5.7-2.9c0.8-2.4-0.5-4.9-2.9-5.7c0,0,0,0,0,0l-30.3-9.9c-0.8-0.3-1.2-1.1-1-1.9c0.3-0.8,1.1-1.2,1.9-1l30.3,9.9
              c0,0,0,0,0,0c1.2,0.4,2.4,0.3,3.5-0.3c1.1-0.5,1.9-1.5,2.3-2.6c0.8-2.4-0.5-4.9-2.9-5.7l-4.1-1.3l-26.2-8.6
              c-0.8-0.3-1.2-1.1-1-1.9c0.3-0.8,1.1-1.2,1.9-1l26.1,8.6c0,0,0,0,0.1,0c1.2,0.4,2.4,0.3,3.5-0.3c1.1-0.5,1.9-1.5,2.3-2.6
              c0.8-2.4-0.5-4.9-2.9-5.7l-44.8-14.7l-3.9,3.5C1707.8,477.2,1706.3,478,1704.8,478.3z"/>
            <path class="st2" d="M1745.9,518.5"/>
          </g>
          <path class="st2" d="M1784.3,477.4C1784.3,477.4,1784.3,477.4,1784.3,477.4l-0.1-0.5c-0.1-0.3-0.1-0.6-0.2-0.9c0,0,0,0,0,0
            c-0.2-1.2-0.5-2.3-0.8-3.5c-0.1-0.3-0.2-0.6-0.3-0.9c-0.2-0.8-0.5-1.7-0.7-2.5c-0.1-0.3-0.2-0.7-0.4-1c-0.3-0.8-0.5-1.5-0.8-2.3
            c-0.1-0.4-0.3-0.7-0.4-1c-0.3-0.7-0.6-1.5-0.9-2.2c-0.2-0.4-0.3-0.7-0.5-1.1c-0.3-0.7-0.6-1.4-1-2c-0.2-0.4-0.4-0.8-0.6-1.2
            c-0.3-0.6-0.7-1.2-1-1.8c-0.2-0.4-0.5-0.8-0.7-1.2c-0.3-0.5-0.7-1.1-1-1.6c-0.3-0.5-0.6-0.9-0.9-1.4c-0.3-0.5-0.6-0.9-1-1.3
            c-0.4-0.5-0.7-1-1.1-1.5c-0.3-0.3-0.5-0.7-0.8-1c-0.5-0.6-0.9-1.1-1.4-1.7c-0.1-0.1-0.2-0.2-0.3-0.3c-2.7-3.1-5.6-5.9-8.8-8.5
            c-0.1,0-0.1-0.1-0.2-0.1c-0.7-0.6-1.5-1.1-2.2-1.7c-0.1-0.1-0.3-0.2-0.4-0.3c-0.7-0.5-1.5-1-2.2-1.5c-0.2-0.1-0.4-0.2-0.6-0.4
            c-0.7-0.5-1.5-0.9-2.2-1.4c-0.2-0.1-0.4-0.2-0.6-0.4c-0.5-0.3-1.1-0.6-1.6-0.9c-0.1,0-0.1,0-0.2-0.1c-13.3-7.1-29.1-9.8-45-6.5
            c-16.9,3.5-31,13.3-40.3,26.3c0,0-0.1,0.1-0.1,0.1c-1.1,1.6-2.2,3.2-3.1,4.9c0,0,0,0.1-0.1,0.1c-0.5,0.8-0.9,1.6-1.3,2.4
            c-0.1,0.2-0.2,0.4-0.3,0.6c-0.3,0.7-0.7,1.4-1,2c-0.2,0.4-0.4,0.7-0.5,1.1c-0.2,0.5-0.5,1.1-0.7,1.6c-0.2,0.6-0.5,1.1-0.7,1.7
            c-0.1,0.4-0.3,0.8-0.4,1.1c-0.3,0.8-0.6,1.6-0.8,2.4c-0.1,0.2-0.1,0.4-0.2,0.6c-3.3,10.5-4.1,22-1.7,33.6c0,0,0,0,0,0
            c0.2,0.8,0.4,1.7,0.6,2.6c0.2,0.6,0.3,1.2,0.5,1.8c0,0,0,0,0,0.1c0,0,0,0,0,0c9.4,33.2,43.2,54,77.5,46.8
            C1768,547.2,1790.9,512.7,1784.3,477.4z M1727.8,490.3l26.2,8.6l4.1,1.3c2.4,0.8,3.7,3.3,2.9,5.7c-0.4,1.2-1.2,2.1-2.3,2.6
            c-1.1,0.6-2.3,0.6-3.5,0.3c0,0,0,0,0,0l-0.5-0.2l-29.8-9.8c-0.8-0.3-1.7,0.2-1.9,1c-0.3,0.8,0.2,1.7,1,1.9l29.9,9.8l0.4,0.1
            c2.4,0.8,3.7,3.3,2.9,5.7c-0.8,2.4-3.3,3.7-5.7,2.9l-5.3-1.7l-0.3-0.1l-24.7-8.1c-0.8-0.3-1.7,0.2-1.9,1c-0.1,0.3-0.1,0.5,0,0.8
            c0.1,0.5,0.5,1,1,1.1l24,7.9l0.7,0.2c0,0,0,0,0,0c1.1,0.4,2.1,1.2,2.6,2.3c0.5,1.1,0.6,2.3,0.3,3.5c-0.8,2.4-3.3,3.7-5.7,2.9
            l-70.3-23l14.1-43.1l8.3,2.7c-0.8,2.5-0.6,5.2,0.8,7.4c1.4,2.4,3.8,4,6.5,4.4c1.1,0.2,2.2,0.1,3.2-0.1c1.5-0.3,3-1,4.2-2.1
            l3.9-3.5l44.8,14.7c2.4,0.8,3.7,3.3,2.9,5.7c-0.4,1.1-1.2,2.1-2.3,2.6c-1.1,0.5-2.3,0.6-3.5,0.3c0,0,0,0-0.1,0l-26.1-8.6
            c-0.8-0.3-1.7,0.2-1.9,1C1726.5,489.2,1727,490,1727.8,490.3z M1758.7,484.5l-43.2-14.1l0,0l0.4-0.4c2.9-2.6,7.2-5.4,13.7-3.7
            c0.8,0.2,1.6-0.3,1.9-1.1c0.2-0.8-0.3-1.6-1.1-1.9c-8-2.1-13.3,1.5-16.5,4.4l-1.7,1.5l-2.6,2.3l-2.6,2.3c-1.4,1.2-3.2,1.8-5,1.5
            c-1.8-0.3-3.4-1.3-4.3-2.9c-0.9-1.5-1-3.3-0.5-4.9c0.3-1,0.9-1.9,1.7-2.7c0.1-0.1,0.1-0.1,0.2-0.2l12-10.8c2.4-2.1,5.4-3.2,8.6-3
            l10.1,0.6c3.1,0.2,6.3-1.3,8-2.3l2.9,3.2c0,0,0,0,0,0l11,12.3l16.9,18.9l-5.5,4.9C1762.3,486.6,1760.7,485.1,1758.7,484.5z
            M1706,427.6c14.5-3,28.8-0.8,41.1,5.3l-12.1,10.9c-0.3,0.3-0.5,0.6-0.5,1c0,0.4,0.1,0.8,0.4,1.1l0.8,0.9
            c-1.5,0.8-3.7,1.8-5.7,1.6l-10.1-0.6c-4-0.2-7.8,1.1-10.8,3.8l-12,10.8c-0.5,0.4-0.9,0.9-1.3,1.4l-8.8-2.9l0.7-2
            c0.3-0.8-0.2-1.7-1-1.9l-17.9-5.9C1677.6,439.5,1690.6,430.8,1706,427.6z M1732.1,551.6c-31.8,6.7-63-11.8-73.1-41.9l9.4,3.1
            c0.3,0.1,0.5,0.1,0.8,0c0.1,0,0.3-0.1,0.4-0.1c0.4-0.2,0.6-0.5,0.8-0.9l0.7-2l70.3,23c1.3,0.4,2.6,0.5,3.9,0.2
            c2.6-0.5,4.8-2.4,5.7-5.1c0.5-1.6,0.5-3.2,0-4.8c3.9,1.2,8.1-1,9.4-4.9c0.8-2.3,0.3-4.8-1-6.7c0.3-0.1,0.7-0.3,1-0.4
            c1.8-0.9,3.1-2.5,3.8-4.4c1.1-3.4-0.4-7.1-3.3-8.9c1.4-0.9,2.5-2.3,3-4c0.2-0.7,0.4-1.5,0.4-2.2l6.7-6l1.4,1.6
            c0.4,0.4,0.9,0.6,1.4,0.5c0.3-0.1,0.5-0.2,0.7-0.4l7.6-6.8C1786.5,513.4,1764.9,544.7,1732.1,551.6z"/>
        </g>
      </g>
      <g>
        
        <ellipse :style="{fill: showClass === 2 ? '#3FB2AA' : ''}" transform="matrix(0.2156 -0.9765 0.9765 0.2156 1027.7197 1724.9559)" class="st1" cx="1587.6" cy="222.8" rx="68.4" ry="68.4"/>
        <g>
          <path class="st2" d="M1577.6,243.4c2.1,0.5,3.8,2.3,4.2,4.6l1.3,6.2c0.2,1.1,1.3,1.8,2.4,1.5l20.8-4.4c1.1-0.2,1.8-1.3,1.5-2.4
            l-1.3-6.2c-0.5-2.3,0.4-4.6,2.1-6c10.8-8.5,15.7-22.1,12.9-35.5c-2.1-10-8.4-18.6-17.2-23.7c-9-5.2-19.3-6.2-29.3-2.9
            c-15.4,5.1-25.6,20.5-24.4,36.7C1551.9,226.7,1562.7,239.6,1577.6,243.4z M1587,226.1c-3.8,0.6-7.8,0.2-11.4-1.3
            c-6.6-2.7-11.5-8.6-12.8-15.6c5.4-3.8,12.3-4.8,18.6-2.8c0,0.3-0.1,0.7-0.1,1c0,0.3-0.1,0.7-0.1,1c0,0.8,0,1.5,0,2.3
            c0,0.2,0,0.5,0,0.7c0.1,1,0.2,2,0.4,3c0,0.1,0,0.2,0,0.2l-11.8-4.8c-1-0.4-2.2,0.1-2.6,1.1c-0.4,1,0.1,2.2,1.1,2.6l14.8,6
            c0.1,0.2,0.2,0.4,0.3,0.6c0.1,0.3,0.3,0.6,0.4,1c0.3,0.7,0.7,1.3,1.1,1.9c0.1,0.2,0.3,0.5,0.4,0.7
            C1585.8,224.6,1586.4,225.4,1587,226.1z M1597.6,194.9c-1.1-0.2-2.1,0.5-2.4,1.5l-5.5,26.6c-0.2-0.3-0.5-0.6-0.7-0.9
            c-0.2-0.3-0.5-0.7-0.7-1c-0.3-0.4-0.5-0.9-0.7-1.3c-0.2-0.4-0.4-0.7-0.5-1.1c-0.2-0.5-0.4-0.9-0.6-1.4c-0.1-0.4-0.3-0.7-0.4-1.1
            c-0.2-0.5-0.3-1-0.4-1.5c-0.1-0.4-0.2-0.7-0.3-1.1c-0.1-0.5-0.1-1.1-0.2-1.6c0-0.4-0.1-0.7-0.1-1.1c0-0.6,0-1.2,0-1.8
            c0-0.3,0-0.6,0-0.9c0.1-0.9,0.2-1.8,0.4-2.7c0,0,0,0,0,0l0,0c0,0,0,0,0,0c1.5-7,6.4-12.8,13.1-15.4c5,5,7.3,12.4,5.8,19.4
            c-1.3,6.2-5.3,11.4-10.8,14.4l5.6-26.7C1599.4,196.2,1598.7,195.1,1597.6,194.9z M1554.7,211c-1.1-14.3,8-28,21.6-32.6
            c8.8-2.9,18.1-2,26,2.6c7.9,4.5,13.4,12.2,15.3,21.1c2.5,11.9-1.9,24-11.5,31.6c-2.9,2.3-4.3,6.2-3.5,9.9l0.9,4.3l-6.5,1.4
            l-4.3-20.6c7.9-3.1,13.9-10,15.6-18.3c1.8-8.8-1.2-17.9-7.9-23.9c-0.5-0.5-1.3-0.6-2-0.4c-7.8,2.6-13.8,8.9-16.2,16.6
            c-7.8-2.4-16.3-0.9-22.8,4.2c-0.6,0.4-0.8,1.1-0.8,1.8c1.2,8.9,7.2,16.5,15.5,19.9c4.6,1.9,9.8,2.3,14.6,1.3c0,0,0.1,0,0.1,0
            l4.2,20.2l-6.5,1.4l-0.9-4.2c-0.8-3.7-3.6-6.7-7.1-7.6C1565.4,236.1,1555.7,224.7,1554.7,211z"/>
          <path class="st2" d="M1606.9,254.5l-20.8,4.4c-1.1,0.2-1.8,1.3-1.5,2.4c0.2,1.1,1.3,1.8,2.4,1.5l20.8-4.4c1.1-0.2,1.8-1.3,1.5-2.4
            S1608,254.3,1606.9,254.5z"/>
          <path class="st2" d="M1610.8,263.1c-0.2-1.1-1.3-1.8-2.4-1.5l-20.8,4.4c-1.1,0.2-1.8,1.3-1.5,2.4c0.2,1.1,1.3,1.8,2.4,1.5
            l20.8-4.4C1610.3,265.3,1611,264.2,1610.8,263.1z"/>
          <path class="st2" d="M1592.9,272.2c-1.1,0.2-1.8,1.3-1.5,2.4c0.2,1.1,1.3,1.8,2.4,1.5l13.2-2.8c1.1-0.2,1.8-1.3,1.5-2.4
            c-0.2-1.1-1.3-1.8-2.4-1.5L1592.9,272.2z"/>
        </g>
      </g>
      <g>
        <path class="st1" d="M436.2,664.1c-11.2,24.1-0.7,52.8,23.5,63.9c24.1,11.2,52.8,0.7,63.9-23.5c11.2-24.1,0.7-52.8-23.5-63.9
          C476,629.5,447.3,640,436.2,664.1z" :style="{fill: showClass === 2 ? '#3FB2AA' : ''}" />
        <g>
          <path class="st2" d="M481,715.7c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c0.2,0,0.3,0,0.5,0c0,0,0,0,0,0c0,0,0,0,0,0c0.2,0,0.4,0,0.6,0
            l0.2,0c0.1,0,0.1,0,0.2,0c0,0,0,0,0,0c1.6-0.1,3.1-0.3,4.6-0.6c10.5-2.2,19.7-9,24.8-18.6c6.1-11.5,5.6-25.5-1.3-36.5
            c-0.3-0.4-0.7-0.7-1.2-0.7c-12.5,0.5-23.9,7.3-30.1,17.9c-10-7.2-23.2-8.9-34.8-4.3c-0.5,0.2-0.8,0.6-0.9,1.1
            c-1.9,12.9,3.3,25.9,13.5,34C464.1,713.2,472.4,716,481,715.7z M509,662.1c6,10.1,6.3,22.7,0.8,33c-5.2,9.8-15.1,16.4-26.1,17.7
            l20.8-39.2c0.4-0.7,0.1-1.5-0.6-1.9c-0.7-0.4-1.5-0.1-1.9,0.6l-20.8,39.2c0,0,0-0.1,0-0.1c-0.2-0.4-0.4-0.7-0.6-1.1
            c-0.1-0.3-0.3-0.6-0.4-0.9c-0.2-0.4-0.3-0.8-0.5-1.2c-0.1-0.3-0.2-0.6-0.3-0.9c-0.1-0.4-0.3-0.8-0.4-1.2c-0.1-0.3-0.2-0.6-0.3-0.9
            c-0.1-0.4-0.2-0.8-0.3-1.2c-0.1-0.3-0.2-0.6-0.2-0.9c-0.1-0.4-0.2-0.8-0.3-1.3c-0.1-0.3-0.1-0.6-0.2-0.9c-0.1-0.4-0.1-0.9-0.2-1.3
            c0-0.3-0.1-0.6-0.1-0.9c0-0.4-0.1-0.9-0.1-1.3c0-0.3,0-0.6,0-0.9c0-0.4,0-0.9,0-1.3c0-0.3,0-0.6,0-0.9c0-0.4,0-0.9,0.1-1.3
            c0-0.3,0-0.6,0.1-0.8c0-0.4,0.1-0.9,0.2-1.3c0-0.3,0.1-0.6,0.1-0.8c0.1-0.4,0.2-0.9,0.3-1.3c0.1-0.3,0.1-0.5,0.2-0.8
            c0.1-0.4,0.2-0.9,0.3-1.3c0.1-0.3,0.1-0.5,0.2-0.8c0.1-0.4,0.3-0.9,0.4-1.3c0.1-0.3,0.2-0.5,0.3-0.8c0.2-0.5,0.4-0.9,0.6-1.4
            c0.1-0.2,0.2-0.4,0.3-0.6c0.3-0.7,0.6-1.3,1-2c0,0,0,0,0,0c0,0,0,0,0,0C486.7,669.5,497.3,662.8,509,662.1z M446.6,675.2
            c10.6-3.9,22.6-2.2,31.7,4.4c-0.1,0.2-0.2,0.4-0.3,0.7c-0.1,0.3-0.3,0.6-0.4,0.9c-0.2,0.4-0.4,0.8-0.5,1.3
            c-0.1,0.3-0.2,0.6-0.3,0.9c-0.2,0.4-0.3,0.9-0.4,1.3c-0.1,0.3-0.2,0.6-0.3,0.8c-0.1,0.5-0.3,1-0.4,1.5c-0.1,0.2-0.1,0.5-0.2,0.7
            c-0.2,0.7-0.3,1.4-0.4,2.1c0,0.1,0,0.1,0,0.2c-0.1,0.7-0.2,1.5-0.3,2.2c0,0.3,0,0.5-0.1,0.8c0,0.5-0.1,1-0.1,1.5
            c0,0.3,0,0.6,0,0.9c0,0,0,0.1,0,0.1L457,681.6c-0.6-0.5-1.5-0.4-2,0.2c-0.5,0.6-0.4,1.5,0.2,2l19.4,15.3c0,0.3,0.1,0.5,0.1,0.8
            c0,0.4,0.1,0.8,0.2,1.2c0.1,0.3,0.1,0.7,0.2,1c0.1,0.4,0.2,0.8,0.2,1.2c0.1,0.3,0.1,0.7,0.2,1c0.1,0.4,0.2,0.8,0.3,1.2
            c0.1,0.3,0.2,0.7,0.3,1c0.1,0.4,0.3,0.8,0.4,1.2c0.1,0.3,0.2,0.6,0.3,0.9c0.2,0.5,0.4,0.9,0.6,1.4c0.1,0.3,0.2,0.5,0.3,0.8
            c0.3,0.7,0.6,1.4,1,2c-7.2-0.2-14.1-2.8-19.7-7.2C449.9,698.4,445.2,686.8,446.6,675.2z"/>
        </g>
      </g>
      <g>
        <path class="st1" d="M314.2,277.4c-15.9,34.3-1,75,33.3,90.8c34.3,15.9,75,1,90.8-33.3c15.9-34.3,1-75-33.3-90.8
          C370.8,228.2,330.1,243.1,314.2,277.4z" :style="{fill: showClass === 2 ? '#3FB2AA' : ''}" />
        <g>
          <path class="st2" d="M358.9,353.1l22.4-4.7c1-0.2,1.6-1.2,1.4-2.1l-4.7-22.3c-0.2-1-1.2-1.6-2.1-1.4l-21.9,4.6l0.8-3.3
            c0,0,0,0,0,0l2.2-8.8l4.4,1c0.8,0.2,1.5-0.2,1.9-0.8c0.4-0.7,0.3-1.5-0.2-2.1l-13-15.2c-0.5-0.6-1.4-0.8-2.1-0.5l-18.4,8.1
            c-0.7,0.3-1.1,1-1.1,1.8c0.1,0.8,0.6,1.4,1.4,1.6l3.3,0.8l-3.3,11.5c-0.5,1.8-0.1,3.7,1.2,5.1l22.6,25.1
            C355.1,352.9,357,353.5,358.9,353.1z M374.9,326.5l3.9,18.8l-20.7,4.3c-0.6,0.1-1.3-0.1-1.7-0.6l-1-1.2c0,0,0,0,0,0
            c-3.2-3.6-4.4-8.5-3.3-13.1l0.9-3.7L374.9,326.5z M333.5,322.2l3.8-13.3c0.1-0.5,0.1-1-0.2-1.4c-0.2-0.4-0.6-0.7-1.1-0.8l12.2-5.4
            l8.6,10.1l-0.8-0.2c-0.9-0.2-1.9,0.4-2.1,1.3l-4.1,16.6c0,0,0,0,0,0l-1.2,4.8c-0.5,2-0.6,4-0.4,6l-14.3-16
            C333.5,323.5,333.4,322.8,333.5,322.2z"/>
          <path class="st2" d="M408.7,281.3c-0.7-0.7-1.8-0.8-2.5-0.1l-17,15.2c-0.7,0.7-0.8,1.8-0.1,2.5l14.9,16.7l-12,3.5l-1.3-4.3
            c-0.2-0.7-0.9-1.2-1.7-1.3c-0.8,0-1.5,0.5-1.7,1.2l-6.7,18.9c-0.3,0.7,0,1.6,0.6,2l16.2,11.8c0.4,0.3,0.9,0.4,1.4,0.3
            c0.2,0,0.5-0.1,0.7-0.3c0.6-0.4,0.9-1.3,0.7-2l-1-3.3l11.6-2.9c1.8-0.5,3.2-1.8,3.8-3.5l10-30.6c0,0,0,0,0,0c0,0,0,0,0,0l0.5-1.5
            c0.6-1.8,0.2-3.8-1.1-5.3L408.7,281.3z M392.9,297.8l14.3-12.8l14.1,15.7c0.4,0.5,0.6,1.1,0.4,1.8l-0.5,1.5
            c-1.5,4.6-5.1,8.1-9.7,9.4l-3.7,1.1L392.9,297.8z M411.1,334.6c-0.2,0.6-0.7,1-1.3,1.2l-13.5,3.4c-0.5,0.1-0.9,0.4-1.1,0.9
            c-0.2,0.4-0.3,0.9-0.2,1.3l-10.8-7.9l4.5-12.5l0.2,0.8c0.3,0.9,1.3,1.5,2.2,1.2l16.4-4.7c0,0,0,0,0,0l4.7-1.4
            c2-0.6,3.8-1.5,5.4-2.6L411.1,334.6z"/>
          <path class="st2" d="M338,293.5l21.6,7.1c0.3,0.1,0.6,0.1,0.9,0.1c0.6-0.1,1.1-0.6,1.3-1.2l7-21.3l2.5,2.4c0,0,0,0,0,0l6.5,6.3
            l-3,3.3c-0.5,0.6-0.6,1.4-0.3,2.1c0.4,0.7,1.1,1,1.9,0.9l19.7-3.6c0.8-0.1,1.4-0.8,1.5-1.6l2.1-20c0.1-0.8-0.3-1.5-1-1.8
            c-0.7-0.3-1.5-0.2-2.1,0.4l-2.3,2.5l-8.3-8.6c-1.3-1.3-3.1-1.9-5-1.5c0,0,0,0,0,0l-31.5,6.6c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0
            l-1.5,0.3c-1.9,0.4-3.4,1.8-4,3.6l-7.1,21.8C336.6,292.2,337.1,293.2,338,293.5z M381.8,262.4
            C381.8,262.4,381.8,262.4,381.8,262.4c0.6-0.1,1.2,0.1,1.7,0.5l9.7,10c0.3,0.4,0.8,0.6,1.3,0.5c0.5,0,0.9-0.2,1.2-0.5l-1.4,13.3
            l-13.1,2.4l0.6-0.6c0.7-0.7,0.6-1.8-0.1-2.5l-7.8-7.5l0,0l-8.1-7.8c-1.5-1.4-3.2-2.5-5-3.4L381.8,262.4z M347.4,270.5
            c0.2-0.6,0.7-1.1,1.3-1.2l1.5-0.3c4.7-1,9.6,0.4,13,3.7l2.8,2.6l-7,21.2l-18.2-6L347.4,270.5z"/>
        </g>
      </g>
      <g>
        <path class="st1" d="M128.1,565.5c-18.6,40.2-1.1,87.9,39.1,106.6c40.2,18.6,87.9,1.1,106.6-39.1c18.6-40.2,1.1-87.9-39.1-106.6
          C194.5,507.7,146.8,525.2,128.1,565.5z" :style="{fill: showClass === 3 ? '#3FB2AA' : ''}" />
        <g>
          <path class="st2" d="M216.6,547.5c-8.1,1.7-13.3,9.7-11.6,17.8c1.7,8.1,9.7,13.3,17.8,11.6c8.1-1.7,13.3-9.7,11.6-17.8
            S224.7,545.8,216.6,547.5z M221.9,572.9c-5.9,1.2-11.7-2.5-12.9-8.4c-1.2-5.9,2.5-11.7,8.4-12.9c5.9-1.2,11.7,2.5,12.9,8.4
            C231.6,565.9,227.8,571.7,221.9,572.9z"/>
          <path class="st2" d="M212.4,537.3l1,4.9c0.2,1.1,1.3,1.8,2.5,1.6c1.1-0.2,1.8-1.3,1.6-2.5l-1-4.9c-0.2-1.1-1.3-1.8-2.5-1.6
            C212.8,535.1,212.1,536.2,212.4,537.3z"/>
          <path class="st2" d="M201,541.4c-0.9,0.8-0.9,2.1-0.2,2.9l3.4,3.8c0.5,0.6,1.3,0.8,2,0.6c0.3-0.1,0.7-0.2,1-0.5
            c0.9-0.8,0.9-2.1,0.2-2.9l-3.4-3.8C203.2,540.7,201.9,540.6,201,541.4z"/>
          <path class="st2" d="M200.5,553.8l-4.8-1.6c-1.1-0.4-2.3,0.2-2.6,1.3c-0.4,1.1,0.2,2.3,1.3,2.6l4.8,1.6c0.4,0.1,0.7,0.1,1.1,0.1
            c0.7-0.1,1.3-0.7,1.5-1.4C202.2,555.3,201.6,554.1,200.5,553.8z"/>
          <path class="st2" d="M194.8,569.6l4.9-1c1.1-0.2,1.8-1.3,1.6-2.5c-0.2-1.1-1.3-1.8-2.5-1.6l-4.9,1c-1.1,0.2-1.8,1.3-1.6,2.5
            S193.6,569.8,194.8,569.6z"/>
          <path class="st2" d="M200.8,581.6c0.3-0.1,0.7-0.2,1-0.5l3.8-3.4c0.9-0.8,0.9-2.1,0.2-2.9c-0.8-0.9-2.1-0.9-2.9-0.2L199,578
            c-0.9,0.8-0.9,2.1-0.2,2.9C199.4,581.5,200.1,581.7,200.8,581.6z"/>
          <path class="st2" d="M211.2,581.4l-1.6,4.8c-0.4,1.1,0.2,2.3,1.3,2.6c0.4,0.1,0.7,0.1,1.1,0.1c0.7-0.1,1.3-0.7,1.5-1.4l1.6-4.8
            c0.4-1.1-0.2-2.3-1.3-2.6C212.8,579.7,211.6,580.3,211.2,581.4z"/>
          <path class="st2" d="M222,583.1l1,4.9c0.2,1.1,1.3,1.8,2.5,1.6c1.1-0.2,1.8-1.3,1.6-2.5l-1-4.9c-0.2-1.1-1.3-1.8-2.5-1.6
            C222.4,580.9,221.7,582,222,583.1z"/>
          <path class="st2" d="M232.2,576.2c-0.9,0.8-0.9,2.1-0.2,2.9l3.4,3.8c0.5,0.6,1.3,0.8,2,0.6c0.3-0.1,0.7-0.2,1-0.5
            c0.9-0.8,0.9-2.1,0.2-2.9l-3.4-3.8C234.4,575.6,233.1,575.5,232.2,576.2z"/>
          <path class="st2" d="M237.6,568.1c-0.4,1.1,0.2,2.3,1.3,2.6l4.8,1.6c0.4,0.1,0.7,0.1,1.1,0.1c0.7-0.1,1.3-0.7,1.5-1.4
            c0.4-1.1-0.2-2.3-1.3-2.6l-4.8-1.6C239.1,566.4,237.9,567,237.6,568.1z"/>
          <path class="st2" d="M244.6,554.9l-4.9,1c-1.1,0.2-1.8,1.3-1.6,2.5s1.3,1.8,2.5,1.6l4.9-1c1.1-0.2,1.8-1.3,1.6-2.5
            S245.8,554.7,244.6,554.9z"/>
          <path class="st2" d="M240.4,546.5c0.9-0.8,0.9-2.1,0.2-2.9c-0.8-0.9-2.1-0.9-2.9-0.2l-3.8,3.4c-0.9,0.8-0.9,2.1-0.2,2.9
            c0.5,0.6,1.3,0.8,2,0.6c0.3-0.1,0.7-0.2,1-0.5L240.4,546.5z"/>
          <path class="st2" d="M225.8,537l-1.6,4.8c-0.4,1.1,0.2,2.3,1.3,2.6c0.4,0.1,0.7,0.1,1.1,0.1c0.7-0.1,1.3-0.7,1.5-1.4l1.6-4.8
            c0.4-1.1-0.2-2.3-1.3-2.6C227.3,535.3,226.2,535.9,225.8,537z"/>
          <path class="st2" d="M237.2,590.3c-0.5-0.7-1.3-1.1-2.2-0.9l-17.3,3.6l-17.3,3.6l-17.3,3.6l-17.3,3.6c-0.8,0.2-1.5,0.8-1.6,1.7
            l-7.5,44.7c-0.1,0.7,0.1,1.4,0.6,1.8s1.2,0.7,1.9,0.5l6.7-1.4l1,5c0.2,1.1,1.3,1.8,2.5,1.6l84.1-17.6c1.1-0.2,1.8-1.3,1.6-2.5
            l-1-5l6.7-1.4c0.7-0.1,1.2-0.6,1.5-1.2s0.2-1.4-0.2-1.9L237.2,590.3z M244.4,609l-16.7,3.5l-6.7-15.9l13.4-2.8L244.4,609z
            M186.2,642.8l-0.2-17.3l17.6-3.7l3.5,16.6L186.2,642.8z M207.7,620.9l17.6-3.7l6.7,15.9l-20.9,4.4L207.7,620.9z M223.6,613.3
            l-16.8,3.5l-3.5-16.6l13.6-2.8L223.6,613.3z M202.8,617.7l-16.8,3.5l-0.2-17.3l13.6-2.8L202.8,617.7z M168.1,607.7l13.4-2.8
            l0.2,17.3l-16.7,3.5L168.1,607.7z M164.4,630c0.1,0,0.1,0,0.2,0l17.2-3.6l0.2,17.3l-15,3.1l-5.7,1.2L164.4,630z M250.6,636.5
            l-80,16.8l-0.6-2.9l14.6-3.1L210,642l25.4-5.3l14.6-3.1L250.6,636.5z M251.2,629.1l-15,3.1l-6.7-15.9l17.2-3.6
            c0.1,0,0.1-0.1,0.2-0.1l10,15.3L251.2,629.1z"/>
        </g>
      </g>
      <g>
        <path class="st1" d="M1437.8,377.1c-10.8,23.4-0.7,51.2,22.7,62c23.4,10.8,51.2,0.7,62-22.7c10.8-23.4,0.7-51.2-22.7-62
          C1476.4,343.5,1448.7,353.7,1437.8,377.1z" :style="{fill: showClass === 3 ? '#3FB2AA' : ''}" />
        <g>
          <path class="st2" d="M1455,399c0.8-0.3,1.1-1.2,0.8-2c-0.6-1.4-1.1-3-1.4-4.5c-0.2-0.8-1-1.3-1.8-1.2c-0.8,0.2-1.3,1-1.2,1.8
            c0.4,1.7,0.9,3.5,1.6,5.1c0.3,0.7,1,1,1.7,0.9C1454.8,399,1454.9,399,1455,399z"/>
          <path class="st2" d="M1497.7,403.2c-0.9,1.3-2,2.4-3.2,3.5c-0.6,0.6-0.7,1.5-0.1,2.1c0.4,0.4,0.9,0.6,1.4,0.5
            c0.3-0.1,0.5-0.2,0.7-0.4c1.3-1.2,2.5-2.5,3.6-3.9c0.5-0.7,0.4-1.6-0.3-2.1C1499.2,402.3,1498.2,402.5,1497.7,403.2z"/>
          <path class="st2" d="M1492.4,364.7c-0.7-0.4-1.7-0.2-2.1,0.5c-0.4,0.7-0.2,1.7,0.5,2.1c8.3,4.8,12.9,14.1,11.8,23.5l-19.3-7.7
            l-6-21.9c-0.2-0.8-1-1.3-1.8-1.1l-6.2,1.3c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c-10.9,3.8-18.3,14.1-18.4,25.6c0,0.8,0.7,1.5,1.5,1.5
            c0.1,0,0.2,0,0.3,0c0.7-0.1,1.2-0.8,1.2-1.5c0.1-9.7,5.9-18.4,14.7-22.1l3,20.5l-15.9,16.1c-0.6,0.6-0.6,1.5-0.1,2.1l4.2,4.7
            c0.2,0.2,0.3,0.3,0.5,0.4c0.1,0.1,0.1,0.1,0.1,0.2c4.9,4.3,11.1,6.6,17.3,6.7l3.6,21.4c0.1,0.4,0.3,0.8,0.6,1
            c0.3,0.2,0.8,0.3,1.2,0.2l10.8-2.3c0.4-0.1,0.8-0.3,1-0.7c0.2-0.4,0.3-0.8,0.2-1.2l-5.3-21c0.7-0.3,1.4-0.7,2-1
            c0.7-0.4,1-1.3,0.6-2.1c-0.4-0.7-1.3-1-2.1-0.6c-0.4,0.2-0.9,0.5-1.3,0.7l-3.6-14l16.1,4.2c0.2,0.1,0.5,0.1,0.7,0
            c0.5-0.1,1-0.5,1.1-1l1.8-5.4c0.1-0.2,0.2-0.4,0.3-0.6C1507.6,382.1,1502.4,370.6,1492.4,364.7z M1463.3,407.6l11.5-9.1l2.4,14.3
            C1472.3,412.6,1467.4,410.8,1463.3,407.6z M1491.8,433.6l-7.7,1.6l-3.2-19.5c1.1-0.1,2.1-0.3,3.1-0.5c1-0.2,2-0.5,3-0.8
            L1491.8,433.6z M1482.1,395.4l4.1,16.1c-1.9,0.7-3.9,1.1-5.9,1.2l-2.7-16.4l2-1.6L1482.1,395.4z M1500.9,397.2l-21.3-5.5
            c-0.2-0.1-0.5-0.1-0.7,0c-0.2,0-0.4,0.1-0.6,0.3l-17.2,13.6l-2.3-2.6l15.4-15.6c0.3-0.3,0.5-0.8,0.4-1.3l-3.2-21.8l3.4-0.7
            l5.8,21.2c0.1,0.5,0.5,0.8,0.9,1l20.4,8.1L1500.9,397.2z"/>
          <path class="st2" d="M1486.2,365.3c0.3,0.1,0.5,0.1,0.8,0c0.5-0.1,1-0.5,1.1-1c0.3-0.8-0.2-1.7-1-1.9c-1.7-0.6-3.4-0.9-5.2-1.2
            c-0.8-0.1-1.6,0.5-1.7,1.3c-0.1,0.8,0.5,1.6,1.3,1.7C1483.1,364.4,1484.7,364.8,1486.2,365.3z"/>
          <path class="st2" d="M1479.1,386.9c-0.7-0.4-1.7-0.2-2.1,0.4c-0.1,0.2-0.2,0.3-0.2,0.5c0,0.2,0,0.4,0,0.6c0.1,0.4,0.3,0.7,0.7,1
            c0.3,0.2,0.8,0.3,1.2,0.2c0.4-0.1,0.7-0.3,1-0.7c0.2-0.3,0.3-0.7,0.2-1.1c0-0.2-0.1-0.4-0.2-0.6
            C1479.4,387.2,1479.2,387,1479.1,386.9z"/>
        </g>
      </g>
      <g>
        <path class="st1" d="M1734.8,677.2c-12.2,26.4-0.7,57.8,25.7,70c26.4,12.2,57.8,0.7,70-25.7c12.2-26.4,0.7-57.8-25.7-70
          C1778.3,639.2,1747,650.7,1734.8,677.2z" :style="{fill: showClass === 3 ? '#3FB2AA' : ''}" />
        <g>
          <path class="st2" d="M1746.6,699.8l9.6-2c0.8-0.2,1.3-0.8,1.3-1.6c0.1-11.4,8.2-21.4,19.5-23.6c10.5-2.1,21.2,3,26.2,12.3
            l-3.3,0.7c-0.7,0.1-1.2,0.6-1.3,1.3c-0.1,0.7,0.2,1.3,0.7,1.7l12.6,8.3c0.4,0.3,0.8,0.3,1.2,0.2c0.4-0.1,0.8-0.3,1-0.7l8.3-12.6
            c0.4-0.6,0.4-1.3,0-1.8c-0.4-0.6-1-0.8-1.7-0.7l-4.5,0.9c-6.7-16.4-24.5-25.9-41.9-22.4c-17.9,3.6-30.7,20.2-29.8,38.4
            c0,0.5,0.3,0.9,0.6,1.2C1745.6,699.8,1746.1,699.9,1746.6,699.8z M1775,663.1c16.3-3.3,33,6,38.7,21.6c0.3,0.8,1.1,1.2,1.9,1.1
            l1.9-0.4l-5.2,7.9l-7.9-5.2l1.5-0.3c0.5-0.1,0.9-0.4,1.1-0.9c0.2-0.4,0.3-1,0.1-1.4c-5.1-11.9-18.1-18.7-30.8-16.1
            c-12.3,2.5-21.4,13.1-22.1,25.5l-6.4,1.3C1747.9,680.3,1759.3,666.3,1775,663.1z"/>
          <path class="st2" d="M1744.4,717.3l4.5-0.9c6.7,16.4,24.5,25.9,41.9,22.4c17.9-3.6,30.7-20.2,29.8-38.4c0-0.5-0.3-0.9-0.6-1.2
            c-0.4-0.3-0.9-0.4-1.3-0.3l-9.6,2c-0.8,0.2-1.3,0.8-1.3,1.6c-0.1,11.4-8.2,21.4-19.5,23.6c-10.5,2.1-21.2-3-26.2-12.3l3.3-0.7
            c0.7-0.1,1.2-0.6,1.3-1.3c0.1-0.7-0.2-1.3-0.7-1.7l-12.6-8.3c-0.8-0.5-1.8-0.3-2.3,0.5l-8.3,12.6c-0.4,0.6-0.4,1.3,0,1.8
            C1743.1,717.1,1743.8,717.4,1744.4,717.3z M1752.9,705.4l7.9,5.2l-1.5,0.3c-0.5,0.1-0.9,0.4-1.1,0.9c-0.2,0.4-0.3,1-0.1,1.4
            c5.1,11.9,18.1,18.7,30.8,16.1c12.3-2.5,21.4-13.1,22.1-25.5l6.4-1.3c-0.1,15.9-11.5,29.9-27.2,33.1c-16.3,3.3-33-6-38.7-21.6
            c-0.3-0.8-1.1-1.2-1.9-1.1l-1.9,0.4L1752.9,705.4z"/>
          <path class="st2" d="M1780.7,721.7c0.2,0.1,0.5,0.1,0.7,0c0.5-0.1,0.9-0.4,1.1-0.8l15.2-28.2c0.3-0.6,0.3-1.3-0.1-1.8
            c-0.4-0.5-1-0.8-1.7-0.6l-9,1.8l2.6-12.1c0.1-0.5,0-1.1-0.4-1.5c-0.4-0.4-1-0.6-1.5-0.5l-16.6,3.4c-0.7,0.1-1.2,0.7-1.3,1.4
            l-2.8,21.5c-0.1,0.5,0.1,1.1,0.5,1.4c0.4,0.4,0.9,0.5,1.5,0.4l10.4-2.1l0.2,16.1C1779.4,720.9,1780,721.5,1780.7,721.7z
            M1770.5,702.5l2.3-18l12.9-2.6l-2.6,12.1c-0.1,0.5,0,1.1,0.4,1.5c0.4,0.4,1,0.6,1.5,0.5l8.1-1.6l-10.5,19.5l-0.2-11.7
            c0-0.5-0.2-1-0.6-1.3s-0.9-0.4-1.4-0.3L1770.5,702.5z"/>
        </g>
      </g>
    </svg>
    <div id="circle">
      <img src="../assets/images/circle.png" alt="" />
    </div>
    <div id="kv-left-top">
      <img src="../assets/images/kv-left-top.png" alt="" />
    </div>
    <div id="kv-left-bottom">
      <img src="../assets/images/kv-left-bottom.png" alt="" />
    </div>
    <div id="kv-right-bottom">
      <img src="../assets/images/kv-right-bottom.png" alt="" />
      <img class="item-1" src="../assets/images/kv-right-bottom-item.png" alt="" />
      <img class="item-2" src="../assets/images/kv-right-bottom-item.png" alt="" />
      <img class="item-3" src="../assets/images/kv-right-bottom-item.png" alt="" />
    </div>
    <div id="center-view">
      <h1 :class="flip ? 'flipInX' : ''">
        <img
          src="../assets/images/newenergyforum2020.png"
          alt="第四屆2020 新能源國際論壇"
          @load="imageLoaded"
        />
      </h1>
      <button
        v-scroll-to="{el: '#register'}"
      >
        立即報名
      </button>
    </div>
    
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      flip: false,
      showClass: this.getRandom(1, 3, 0),
    }
  },
  methods: {
    getRandom(min, max, now) {
      const N =  Math.round(Math.random() * (max - min)) + min;
      if(N === now) {
        return this.getRandom(min, max, now);
      }
      return N;
    },
    setShowClass() {
      this.showClass = this.getRandom(1, 3, this.showClass);
    },
    imageLoaded() {
      this.flip = true;
    }
  },
  mounted() {
    setInterval(this.setShowClass, 3000);
  }
}
</script>

<style>
#main-top {
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
  padding-top: 5em;
  min-height: 100vh;
}
#main-top img {
  display: block;
  width: 100%;
}
#main-top svg {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.st1 {
  transition: 2s;
  fill: #E8F6F5;
}
.st2 {
  fill: #FFFFFF;
}
.st3 {
  fill: none;
}
#circle {
  position: absolute;
  width: 40%;
  top: 50%;
  left: 50%;
  margin-left: -20%;
  margin-top: -20%;
  -webkit-animation: setRotate 30s linear infinite;
  -moz-animation: setRotate 30s linear infinite;
  animation: setRotate 30s linear infinite;
}
@-moz-keyframes setRotate {
  from {
    -moz-transform: rotate(0deg);
  }
  to {
    -moz-transform: rotate(360deg);
  }
}
@-webkit-keyframes setRotate {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}
@keyframes setRotate {
  from {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
#kv-left-top {
  position: absolute;
  width: 65%;
  top: 0;
  left: 0;
  max-width: 1620px;
}
#kv-left-bottom {
  position: absolute;
  width: 40%;
  bottom: 0;
  left: 0;
  max-width: 993px;
}
#kv-right-bottom {
  position: absolute;
  width: 65%;
  bottom: 0;
  right: 0;
  max-width: 1682px;
}
#main-top .item-1 {
  position: absolute;
  width: 26%;
  bottom: 8.5%;
  right: -6.6%;
  -webkit-animation: setRotate 3s linear infinite;
  -moz-animation: setRotate 3s linear infinite;
  animation: setRotate 3s linear infinite;
}
#main-top .item-2 {
  position: absolute;
  width: 19%;
  bottom: 0.5%;
  right: 10.8%;
  -webkit-animation: setRotate 5s linear infinite;
  -moz-animation: setRotate 5s linear infinite;
  animation: setRotate 5s linear infinite;
}
#main-top .item-3 {
  position: absolute;
  width: 16%;
  bottom: -6.5%;
  right: 27.2%;
  -webkit-animation: setRotate 7s linear infinite;
  -moz-animation: setRotate 7s linear infinite;
  animation: setRotate 7s linear infinite;
}
#center-view {
  position: relative;
  width: 55%;
  padding: 5% 0;
  max-width: 1366px;
  margin: 0 auto;
  text-align: center;
}
h1 {
  margin: 0 auto;
}
#center-view button {
  font-size: 1.2em;
  color: white;
  background: #2285BC;
  border: solid 0.2em #FFE576;
  padding: 0.2em 1em;
  margin: 1.6em 0 0;
  border-radius: 2em;
  transform: scale(1);
  transition: .5s;
}

@keyframes flipInX {
  from {
    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    animation-timing-function: ease-in;
    opacity: 0;
  }

  40% {
    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    animation-timing-function: ease-in;
  }

  60% {
    transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
    opacity: 1;
  }

  80% {
    transform: perspective(400px) rotate3d(1, 0, 0, -5deg);
  }

  to {
    transform: perspective(400px);
  }
}
.flipInX {
  animation-duration: 1s;
  animation-fill-mode: both;
  -webkit-backface-visibility: visible !important;
  backface-visibility: visible !important;
  animation-name: flipInX;
}

@media (orientation: portrait) and (min-width: 768px) {
  #main-top {
    min-height: auto;
  }
}

@media (hover: hover) {
  #center-view button:hover {
    transform: scale(1.2);
  }
}

@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  #center-view button:hover {
    transform: scale(1.2);
  }
}

@media screen and (max-width: 640px) {
  #main-top svg {
    width: 300%;
    left: -100%;
  }
  #kv-left-bottom,
  #circle {
    width: 90%;
  }
  #circle {
    margin-left: -45%;
    margin-top: -45%;
  }
  #kv-right-bottom,
  #kv-left-top {
    width: 120%;
  }
  #center-view {
    width: 92%;
    padding: 20% 0;
  }
}
</style>
